(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["moment"], factory);
	else if(typeof exports === 'object')
		exports["Formatters"] = factory(require("moment"));
	else
		root["Formatters"] = factory(root["moment"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_53__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1341);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLanguage", function() { return changeLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneInstance", function() { return cloneInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInstance", function() { return createInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dir", function() { return dir; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exists", function() { return exists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFixedT", function() { return getFixedT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadLanguages", function() { return loadLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadNamespaces", function() { return loadNamespaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadResources", function() { return loadResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaultNamespace", function() { return setDefaultNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "use", function() { return use; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18next_js__ = __webpack_require__(140);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var changeLanguage = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].changeLanguage.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var cloneInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].cloneInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var createInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].createInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var dir = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].dir.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var exists = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].exists.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var getFixedT = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].getFixedT.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var init = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].init.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadLanguages = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadLanguages.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadNamespaces = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadNamespaces.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadResources = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadResources.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var off = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].off.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var on = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].on.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var setDefaultNamespace = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].setDefaultNamespace.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var t = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].t.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var use = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].use.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(72);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(102);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de.yml": 121,
	"./en.yml": 122,
	"./es.yml": 123,
	"./fr.yml": 124,
	"./ja.yml": 125,
	"./pt.yml": 126,
	"./zh.yml": 127
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

module.exports = {"de":{"translation":{"edit_conflict":{"header":"Konflikt bearbeiten","description":"Dieser Eintrag wurde während Ihrer Bearbeitung geändert:","notice":"„{{term}}” wurde während Ihrer Bearbeitung geändert.","options":{"save_your_edit":"Um Ihre Änderungen zu speichern, kopieren Sie den Text aus dem Editor mit der rechten\nMaustaste in Ihre Zwischenablage. Wenn Sie Ihr Display aktualisieren oder auf Änderungen speichern klicken,\nwird der geänderte Eintrag angezeigt.\nSie müssen Ihren Text dann manuell in den neuen Eintrag einfügen.\n","discard_your_changes":"Um Ihre Änderungen zu verwerfen und den neuen Eintrag zu laden,\naktualisieren Sie einfach Ihr Display oder klicken Sie auf Speichern.\n","save_changes":"Um Ihre Änderungen zu speichern, kopieren Sie den Text in ein anderes Programm, aktualisieren Sie Ihren Browser,\noder klicken Sie auf „Speichern” und führen Sie eine manuelle Zusammenführung Ihrer Änderungen durch.\n","discard_changes":"Aktualisieren Sie Ihren Browser, um Ihre Änderungen zu verwerfen."}},"delete_conflict":{"header":"Konflikt löschen","notice":"„{{term}}” wurde gelöscht und ist nicht mehr verfügbar.","options":{"save_changes":"Um Ihre Änderungen zu speichern, kopieren Sie den Text in ein anderes Programm\nund geben Sie die Änderungen in ein neues %{term}-Formular ein.\n","discard_changes":"Schließen Sie das Formular und aktualisieren Sie Ihren Browser, um Ihre Änderungen zu verwerfen."}},"assessment_drivers":{"notifications":{"assessment_disabled":"Dieser Bewertungsfaktor ist momentan deaktiviert."},"activerecord":{"errors":{"messages":{"assessment_driver":{"unreachable":"Bei Speichern des Bewertungsfaktors ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.","metric_deleted":"{{name}} wurde aus der Ergebnisse-App gelöscht und ist nicht mehr verfügbar.","targetable_field_changed":"Die Skala für {{name}} wurde geändert. Überprüfen Sie den Bewertungsfaktor und aktivieren Sie ihn erneut.","metric_updated":"Die Konfiguration von {{name}} wurde in der Ergebnisse-App geändert. Prüfen und aktivieren Sie diesen Bewertungsfaktor erneut.","insufficient_data":"Die Daten reichen zur Berechnung von {{name}} in der Ergebnisse-App nicht aus.","invalid_data":"Der Wert für {{name}} ist {{value}} und kann nicht ordnungsgemäß vom Bewertungsfaktor verarbeitet werden.","saved_failed":"Es gab ein Problem mit dem Server, und wir waren nicht in der Lage, Ihre Änderungen zu speichern. Versuchen Sie es bitte erneut.","no_response":"Wir konnten keine Metriken laden."}}}},"success_saving":"Die {{targetableField}}-Bewertung für „{{target}}” wurde erfolgreich automatisiert.","bubbly_header":"{{target_term}}-Bewertungen automatisieren","bubbly_content_html":"Mit Hilfe von Bewertungsfaktoren können Sie Ihre Bewertungen in Echtzeit aktualisieren. Sie können vordefinierte Metrikbereiche verwenden, um Ihre {{target_term}} zu bewerten und bei Änderungen wichtige Interessensgruppen benachrichtigen. <a target='_blank' rel=\"noopener noreferrer\" class='bubbly__content__link' href=\"{{url}}\">Erfahren Sie mehr.</a>","bubbly_footer":"Diesen Tipp nicht mehr anzeigen.","save":"Speichern","cancel":"Abbrechen","enable":"Bewertungsfaktor aktivieren","delete":"Löschen","delete_popover":{"title":"Bewertungsfaktor löschen?","description":"Sie können auf dieses Element nicht mehr zugreifen oder es wiederherstellen."},"tour":{"description":{"step_one":"Definieren Sie die Bedingungen, die erfüllt werden müssen, damit die {{target_term}}-Bewertung die angegebene Einstufung automatisch aktualisiert.","step_two":"Während Sie Werte in die rechte Spalte eingeben, wird die linke Spalte automatisch mit dem nächsten sequenziellen Wert ausgefüllt."},"navigation":{"back":"Zurück","close":"Schließen","done":"Abgeschlossen","next":"Nächstes"}},"title":{"new":"Neuer Bewertungsfaktor","edit":"Bewertungsfaktor bearbeiten"},"dropdowns":{"entity":"Entität","process":"Prozess","metric":"Metrik","tooltip":"Deaktivieren Sie den Bewertungsfaktor, um die automatische {{target_term}}-Bewertung zu pausieren.","help_icon_text_risk":"Nur Risiken mit verlinkten Metriken können ausgewählt werden.","automated":"%{name} (Automatisierung gesetzt)","placerholder_entity":"%{operating_segment} auswählen...","placeholder_metric":"Metrik auswählen..."},"metric_ranges":{"errors":{"format_error":"Nur Zahlen sind gültige Zeichen.","range_error":"Bereiche dürfen nicht überlappen."},"dropdown":{"less_than":"kleiner als","greater_than":"größer als","equal_to":"oder gleich"}},"more_information":"Weitere Informationen"},"metrics":{"title":"Bisher wurden noch keine Metriken verknüpft","header":"Metriken","add_or_remove":"Hinzufügen/Entfernen","description_html":"Metriken sind quantifizierbare Maßnahmen mit denen {{targetTerm}} verfolgt, überwacht und bewertet werden können. Sie können Metriken mit {{targetTerm}} verknüpfen, um die Risikobewertung mit Informationen zu unterstützen.","start_linking":"Metriken verknüpfen","done_editing":"Abgeschlossen","edit_metrics":"Metriken bearbeiten","view_data":"Daten anzeigen","learn_more":{"label":"Erfahren Sie mehr."},"link_table":{"title":"Zu verknüpfende Metriken auswählen","search_placeholder":"Metriken durchsuchen","no_metrics_available":"Keine Metriken verfügbar, die verknüpft werden können","no_metrics_available_description":"Metriken sind quantifizierbare Maßnahmen mit denen {{targetTerm}} verfolgt, überwacht und bewertet werden können. Nachdem Sie eine Metrik erstellt haben, können Sie diese mit einem {{targetTerm}} verknüpfen.","unlink_confirmation_button":"Verknüpfung aufheben und Änderungen speichern","save":"Speichern","cancel":"Abbrechen","headers":{"metric":"Metrik","table":"Tabelle","collection":"Sammlung"}},"updated_successfully":"Metriken erfolgreich aktualisiert","updated_failed":"Der Datensatz, den Sie bearbeiten, wurde durch einen anderen Benutzer verändert. Ihre vorgenommenen Änderungen wurden nicht gespeichert. Bitte versuchen Sie es erneut.","linked_metric":{"not_found":"{{name}} wurde aus der Ergebnisse-App gelöscht und ist nicht mehr verfügbar.","insufficient_data":"Die Daten reichen zur Berechnung von {{name}} in der Ergebnisse-App nicht aus.","no_response":"Wir konnten keine Metriken laden. Aktualisieren Sie die Seite und versuchen Sie es erneut.","unlink_metric_button":"Verknüpfung mit Metrik aufheben","unlink_metric_header":"Verknüpfung mit Metriken aufheben?","unlink_metric_body":"Wenn Sie die Verknüpfung mit dieser Metrik aufheben, werden alle verbundenen Bewertungsfaktoren endgültig entfernt.","archived_html":"Diese Metrik stammt aus einer <a href=\"{{collection_url}}\" target=\"_blank\" rel=\"noreferrer noopener\">archivierten Sammlung <i class=\"acl-i-arrow-up-b\"></i></a> und ist schreibgeschützt. Es wurden keine Daten hinzugefügt oder geändert."},"add_description":"+ Fügen Sie der Metrik eine Beschreibung hinzu, um den Kontext zu erhöhen...","formatting":{"blank":"(leer)","date":{"default":"D. MMM YYYY"},"time":{"default":"HH:mm:ss","error":"unbekannte Zeit"},"datetime":{"default":"D. MMM YYYY HH:mm:ss"},"numeric":{"abbreviations":{"thousand":"Tsd.","million":"Mio.","billion":"Mrd.","trillion":"Bio."}},"logical":{"true":"T","false":"F"},"labels":{"uniques":"Eindeutige Werte","blanks":"Leere Felder","percent":"% der Summe","count":"Anzahl","positives":"Positive","negatives":"Negative","zeros":"Nullen","total":"Summen","average":"Durchschnitt","lowest":"Niedrigste","highest":"Höchste","standard_deviation":"Std. Abweichung"},"sparkline":{"axis_date":{"day":"D. MMM YYYY","month":"MMM YYYY","quarter":"[Q]Q, YYYY","year":"YYYY"}}},"sparkline":{"reset_zoom":"Vergrößern/Verkleinern zurücksetzen","reset_zoom_tooltip":"Einstellung für Vergrößern/Verkleinern zurücksetzen"},"indicator":{"empty":{"no_sparkline_data":"Zur Erstellung einer Sparkline gibt es nicht genügend Daten.","no_preview_data":"Zur Berechnung dieser Metrik sind keine ausreichenden Daten verfügbar. Versuchen Sie, Ihre Filter zu ändern oder zur Berechnung der Metrik mehr Daten hinzuzufügen."}}},"global_navigation":{"navigation_items":{"logo":"Zurück zum Launchpad","app_switcher":"Apps wechseln","announcer":"Ankündigungen","helper":"Hilfe und Support","user":"Angemeldet: {{username}}","user_with_customer":"{{username}} {{customerName}}","sign_in":"Anmelden"},"apps":{"academy":"Akademie","community":"Community","projects":"Projekte","results":"Ergebnisse","storyboards":"Storyboards","mission_control":"Kontrollzentrum","risks":"Strategie","reports":"Berichte","launchpad":"Launchpad","robots":"Robots","frameworks":"Frameworks","compliance_maps":"Compliance-Maps","assurance_plans":"Sicherungspläne","project_scheduler":"Ablaufplaner","issue_tracker":"Problemverfolgung","task_tracker":"Aufgabenverfolgung","project_timesheets":"Stundennachweise","dashboard":"{{module}}-Dashboard","master_library":"Master-Bibliothek"},"app_sections":{"setup":"Einstellungen","workspace":"Arbeitsbereich","automation":"Automatisierung"},"user":{"my_profile":"Mein Profil","log_out":"Abmelden"},"helper":{"help_docs":"Hilfedokumente","support":"Support"},"skip_button":"Bis Hauptinhalt überspringen","logo":"Logo","other":"Andere","section":"Abschnitt"},"contacts_dropdown":{"contacts":"Ansprechpartner","custom_value_a11y":"{{nameFieldLabel}} Textfeld","custom_value_enter":"{{customValue}} als {{nameFieldLabel}} hinzufügen und eine E-Mail-Adresse manuell eingeben.","select_placeholder":"Benutzer angeben...","search_a11y":"Sie können nach einem Benutzer oder einem Kontakt suchen. Wenn keine Suchergebnisse zurückgegeben werden, verwenden Sie den Suchwert als {{nameFieldLabel}}-Name","search_placeholder":"Benutzer suchen oder einen neuen Namen eingeben...","email_address":"E-Mail-Adresse","email_address_error":"Die E-Mail-Adresse muss gültig sein","users":"Benutzer","contacts_error":"Ihr Kontaktbuch wurde nicht geladen."},"resource_sharing":{"loading_collaborators":"Wird geladen...","add_collaborators_search_placeholder":"Gruppen oder Einzelpersonen suchen...","manage_collaborators":"Mitarbeiter verwalten","close":"Schließen","disabled":"Gesperrt","disabled_a11y_text":"Deaktivierte Gruppe","disabled_group_tooltip":"Diese Gruppe hat <strong>keinen Zugriff</strong>, weil die Gruppe in Launchpad deaktiviert wurde. Systemadministratoren können die Gruppe wieder aktivieren.","add_collaborators":"Mitarbeiter hinzufügen","add_collaborators_loading_tooltip":"Bitte warten Sie, bis die Liste der Personen geladen wurde.","individuals":"Einzelpersonen","individuals_section_tooltip_button":"QuickInfo zum Abschnitt \"Einzelpersonen\"","individuals_section_tooltip":"Der Zugriff einer Person muss mindestens so hoch sein, wie der Zugriff der zugewiesenen Gruppe. <a href=\"{{url}}\" target=\"_blank\" rel=\"noopener noreferrer\">Erfahren Sie mehr</a>.","no_results_found":"Keine Ergebnisse gefunden","show_more":"Mehr anzeigen","remove":"Entfernen","collaborators_widget":{"add":"Hinzufügen","manage":"Verwalten","view":"Anzeigen","more_users_tooltip":"{{remaining_users}} andere"},"side_panel":{"cancel":"Abbrechen","groups_count":"{{count}} Gruppe","groups_count_plural":"{{count}} Gruppen","individuals_count":"{{count}} Person","individuals_count_plural":"{{count}} Personen","title":"‘{{resource_name}}’ freigeben","save":"Speichern"},"groups":"Gruppen","group_members_count":"({{count}} Mitglied)","group_members_count_plural":"({{count}} Mitglieder)","disabled_role":"(deaktiviert)","no_access":"Kein Zugriff","default":"Standard","default_a11y_text":"Standardgruppe","success_message":"{{resource_name}} wurde erfolgreich aktualisiert.","error_message":"Irgendetwas ist fehlgeschlagen. Aktualisieren Sie bitte die Seite und versuchen Sie es erneut. Wenn das Problem erneut auftritt, wenden Sie an unser Support-Team."}}}}

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

module.exports = {"en":{"translation":{"edit_conflict":{"header":"Edit Conflict","description":"This record changed while you were editing:","notice":"This {{term}} changed while you were editing.","options":{"save_your_edit":"To save your edit, copy the text from the editor into your clipboard\nusing right click of your mouse. When you refresh the screen or click Save Changes,\nthe new record will be loaded.\nYou will need to manually merge your text to the new record.\n","discard_your_changes":"To discard your changes and load the new record,\nsimply refresh the screen or click Save button.\n","save_changes":"To save your changes, copy the text to another program,\nrefresh your browser or click Save, and manually merge your changes.\n","discard_changes":"To discard your changes, refresh your browser."}},"delete_conflict":{"header":"Delete Conflict","notice":"This {{term}} has been deleted and is no longer available.","options":{"save_changes":"To save your changes, copy the text to another program,\nand enter the information in a new %{term} form.\n","discard_changes":"To discard your changes, close the form and refresh your browser."}},"assessment_drivers":{"notifications":{"assessment_disabled":"This Assessment Driver is currently disabled."},"activerecord":{"errors":{"messages":{"assessment_driver":{"unreachable":"A problem occured while saving the Assessment Driver, please try again.","metric_deleted":"{{name}} has been deleted from the Results app and is no longer available.","targetable_field_changed":"The scale for {{name}} has been changed. Review and enable this Assessment Driver again.","metric_updated":"{{name}}'s configuration has been changed in the Results app. Review and enable this Assessment Driver again.","insufficient_data":"There is not enough data to calculate {{name}} in the Results app.","invalid_data":"The value for {{name}} is {{value}} and cannot be properly processed by the Assessment Driver.","saved_failed":"There was a problem with the server and we were unable to save your changes, please try again.","no_response":"We are unable to load Metrics."}}}},"success_saving":"{{target}} {{targetableField}} rating was successfully automated.","bubbly_header":"Automate your {{target_term}} assessments","bubbly_content_html":"Assessment Drivers allow you to keep your assessments current, in real-time. Use pre-defined metric ranges to assess your {{target_term}} and notify key stakeholders when changes occur. <a target='_blank' rel=\"noopener noreferrer\" class='bubbly__content__link' href=\"{{url}}\">Learn more.</a>","bubbly_footer":"Don't show this tip again.","save":"Save","cancel":"Cancel","enable":"Enable Assessment Driver","delete":"Delete","delete_popover":{"title":"Delete Assessment Driver?","description":"You will not be able to access or restore this item."},"tour":{"description":{"step_one":"Define the conditions that need to occur for the {{target_term}} assessment to automatically update to the specified score.","step_two":"As you enter values in the right column, the left column is auto-populated with the next sequential value."},"navigation":{"back":"Back","close":"Close","done":"Done","next":"Next"}},"title":{"new":"New Assessment Driver","edit":"Edit Assessment Driver"},"dropdowns":{"entity":"Entity","process":"Process","metric":"Metric","tooltip":"Disable Assessment Driver to pause automated {{target_term}} assessment.","help_icon_text_risk":"Only risks that have Metrics linked can be selected.","automated":"%{name} (automation set)","placerholder_entity":"Select a(n) %{operating_segment}...","placeholder_metric":"Select a Metric..."},"metric_ranges":{"errors":{"format_error":"Only numbers are valid.","range_error":"Ranges cannot overlap."},"dropdown":{"less_than":"less than","greater_than":"greater than","equal_to":"or equal to"}},"more_information":"More information"},"metrics":{"title":"No Metrics Linked Yet","header":"Metrics","add_or_remove":"Add/Remove","description_html":"Metrics are quantifiable measures used to track, monitor, and assess {{targetTerm}}. You can link Metrics to a {{targetTerm}} to help inform the assessment.","start_linking":"Link Metrics","done_editing":"Done","edit_metrics":"Edit Metrics","view_data":"View Data","learn_more":{"label":"Learn more."},"link_table":{"title":"Select Metrics to link","search_placeholder":"Search Metrics","no_metrics_available":"No Metrics Available to Link","no_metrics_available_description":"Metrics are quantifiable measures used to track, monitor, and assess {{targetTerm}}. Once you have created a Metric, you can link it to a {{targetTerm}}.","unlink_confirmation_button":"Unlink and save changes","save":"Save","cancel":"Cancel","headers":{"metric":"Metric","table":"Table","collection":"Collection"}},"updated_successfully":"Successfully updated Metrics","updated_failed":"The record you are working on has been modified by another user. The changes you made were not saved, please try again.","linked_metric":{"not_found":"{{name}} has been deleted from Results and is no longer available.","insufficient_data":"There is not enough data to calculate {{name}} in the Results app.","no_response":"We are unable to load Metrics. Refresh the page to try again.","unlink_metric_button":"Unlink Metric","unlink_metric_header":"Unlink Metrics?","unlink_metric_body":"Unlinking this Metric will permanently remove any associated Assessment Drivers.","archived_html":"This metric is from an <a href=\"{{collection_url}}\" target=\"_blank\" rel=\"noreferrer noopener\">archived collection <i class=\"acl-i-arrow-up-b\"></i></a> and is read-only. No data can be added or changed."},"add_description":"+ Add a description to give the Metric context...","formatting":{"blank":"(blank)","date":{"default":"MMM D, YYYY"},"time":{"default":"h:mm:ss A","error":"unknown time"},"datetime":{"default":"MMM D, YYYY h:mm:ss A"},"numeric":{"abbreviations":{"thousand":"k","million":"m","billion":"b","trillion":"t"}},"logical":{"true":"T","false":"F"},"labels":{"uniques":"Unique Values","blanks":"Blanks","percent":"% of Total","count":"Count","positives":"Positives","negatives":"Negatives","zeros":"Zeros","total":"Total","average":"Average","lowest":"Lowest","highest":"Highest","standard_deviation":"Std. Deviation"},"sparkline":{"axis_date":{"day":"MMM DD, YYYY","month":"MMM, YYYY","quarter":"[Q]Q, YYYY","year":"YYYY"}}},"sparkline":{"reset_zoom":"Reset zoom","reset_zoom_tooltip":"Reset zoom level"},"indicator":{"empty":{"no_sparkline_data":"There isn’t enough data to generate a spark line.​","no_preview_data":"There is not enough data to calculate this metric. Try changing your filters or adding more data to calculate the metric."}}},"global_navigation":{"navigation_items":{"logo":"Back to Launchpad","app_switcher":"Switch Apps","announcer":"Announcements","helper":"Help and Support","user":"Signed in: {{username}}","user_with_customer":"{{username}} {{customerName}}","sign_in":"Sign in"},"apps":{"academy":"Academy","community":"Community","projects":"Projects","results":"Results","storyboards":"Storyboards","mission_control":"Mission Control","risks":"Strategy","reports":"Reports","launchpad":"Launchpad","robots":"Robots","frameworks":"Frameworks","compliance_maps":"Compliance Maps","assurance_plans":"Assurance Plans","project_scheduler":"Scheduler","issue_tracker":"Issue Tracker","task_tracker":"Task Tracker","project_timesheets":"Timesheets","dashboard":"{{module}} Dashboard","master_library":"Master Library"},"app_sections":{"setup":"Setup","workspace":"Workspace","automation":"Automation"},"user":{"my_profile":"My Profile","log_out":"Log Out"},"helper":{"help_docs":"Help Docs","support":"Support"},"skip_button":"Skip to main content","logo":"logo","other":"Other","section":"section"},"contacts_dropdown":{"contacts":"Contacts","custom_value_a11y":"{{nameFieldLabel}} text field","custom_value_enter":"Add {{customValue}} as {{nameFieldLabel}} and manually enter an email address.","select_placeholder":"Specify a user...","search_a11y":"Search for user or contact. If there are no search results then use the search value as the {{nameFieldLabel}} name","search_placeholder":"Search users or enter a new name...","email_address":"Email address","email_address_error":"Email address should be valid","users":"Users","contacts_error":"Your contact book was not loaded."},"resource_sharing":{"loading_collaborators":"Loading...","add_collaborators_search_placeholder":"Search groups or individuals...","manage_collaborators":"Manage collaborators","close":"Close","disabled":"Disabled","disabled_a11y_text":"Disabled group","disabled_group_tooltip":"This group has <strong>no access</strong> because the group has been disabled in Launchpad. System admins can re-enable the group.","add_collaborators":"Add Collaborators","add_collaborators_loading_tooltip":"Please wait until the list of individuals is loaded.","individuals":"Individuals","individuals_section_tooltip_button":"Individuals Section Tooltip","individuals_section_tooltip":"Individual access must be equal to or higher than assigned group access. <a href=\"{{url}}\" target=\"_blank\" rel=\"noopener noreferrer\">Learn more</a>.","no_results_found":"No results found","show_more":"Show more","remove":"Remove","collaborators_widget":{"add":"Add","manage":"Manage","view":"View","more_users_tooltip":"{{remaining_users}} others"},"side_panel":{"cancel":"Cancel","groups_count":"{{count}} group","groups_count_plural":"{{count}} groups","individuals_count":"{{count}} individual","individuals_count_plural":"{{count}} individuals","title":"Share ‘{{resource_name}}’","save":"Save"},"groups":"Groups","group_members_count":"({{count}} member)","group_members_count_plural":"({{count}} members)","disabled_role":"(disabled)","no_access":"No access","default":"Default","default_a11y_text":"Default group","success_message":"{{resource_name}} was successfully updated.","error_message":"Something went wrong. Please refresh the page to try again. If the problem persists, contact our support team."}}}}

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

module.exports = {"es":{"translation":{"edit_conflict":{"header":"Editar conflicto","description":"Este registro cambió mientras estaba editando:","notice":"Este(a) {{term}} cambió mientras estaba editando.","options":{"save_your_edit":"Para guardar su edición, copie el texto desde el editor en el portapapeles\nhaciendo clic en el botón derecho de su ratón. Al actualizar la pantalla o hacer clic en Guardar cambios,\nse cargará el nuevo registro.\nTendrá que fusionar manualmente el texto con el nuevo registro.\n","discard_your_changes":"Para descartar los cambios y cargar el nuevo registro,\nsimplemente actualizar la pantalla o hacer clic en el botón Guardar.\n","save_changes":"Para guardar los cambios, copie el texto a otro programa,\nactualice el navegador o haga clic en Guardar y combine manualmente los cambios.\n","discard_changes":"Para descartar los cambios, actualice su navegador."}},"delete_conflict":{"header":"Eliminar conflicto","notice":"Este(a) {{term}} se ha eliminado y ya no está disponible.","options":{"save_changes":"Para guardar los cambios, copie el texto a otro programa e\nintroduzca la información en un nuevo formulario de %{term}.\n","discard_changes":"Para descartar los cambios, cierre el formulario y actualice su navegador."}},"assessment_drivers":{"notifications":{"assessment_disabled":"Este controlador de evaluación actualmente está desactivado."},"activerecord":{"errors":{"messages":{"assessment_driver":{"unreachable":"Se ha producido un problema al guardar el controlador de evaluación. Vuelva a intentarlo.","metric_deleted":"{{name}} se ha eliminado de la aplicación Resultados y ya no está disponible.","targetable_field_changed":"Se ha cambiado la escala de {{name}}. Revise y vuelva a habilitar este controlador de evaluación.","metric_updated":"La configuración de {{name}} se ha cambiado en la aplicación Resultados. Revise y active este controlador de evaluación nuevamente.","insufficient_data":"No hay suficientes datos para calcular {{name}} en la aplicación Resultados.","invalid_data":"El valor de {{name}} es {{value}} y no puede ser procesado correctamente por el controlador de evaluación.","saved_failed":"Hubo un problema con el servidor y no pudimos guardar los cambios, intente de nuevo.","no_response":"No podemos cargar Medidas."}}}},"success_saving":"La calificación de {{targetableField}} de {{target}} se automatizó con éxito.","bubbly_header":"Automatice sus evaluaciones de {{target_term}}","bubbly_content_html":"Los controladores de evaluación le permiten mantener sus evaluaciones actualizadas, en tiempo real. Utilice rangos de medidas predefinidos para evaluar su {{target_term}} y notificar a las partes interesadas clave cuando ocurran cambios. <a target='_blank' rel=\"noopener noreferrer\" class='bubbly__content__link' href=\"{{url}}\">Obtener más información.</a>","bubbly_footer":"No mostrar este consejo de nuevo.","save":"Guardar","cancel":"Cancelar","enable":"Habilitar controlador de evaluación","delete":"Eliminar","delete_popover":{"title":"¿Eliminar controlador de evaluación?","description":"No podrá acceder a este elemento ni restaurarlo."},"tour":{"description":{"step_one":"Defina las condiciones que deben ocurrir para que la evaluación de {{target_term}} se actualice automáticamente a la calificación especificada.","step_two":"Cuando se introducen valores en la columna de la derecha, la columna izquierda se rellena automáticamente con el siguiente valor secuencial."},"navigation":{"back":"Atrás","close":"Cerrar","done":"Terminado","next":"Siguiente"}},"title":{"new":"Nuevo controlador de evaluación","edit":"Editar controlador de evaluación"},"dropdowns":{"entity":"Entidad","process":"Proceso","metric":"Medida","tooltip":"Desactive el controlador de evaluación para pausar la evaluación automática de {{target_term}}.","help_icon_text_risk":"Solo se pueden seleccionar los riesgos que tienen medidas enlazadas.","automated":"%{name} (conjunto de automatización)","placerholder_entity":"Seleccione un(a) %{operating_segment}...","placeholder_metric":"Seleccione una medida..."},"metric_ranges":{"errors":{"format_error":"Solo son válidos los números.","range_error":"Los rangos no se pueden superponer."},"dropdown":{"less_than":"menor que","greater_than":"mayor que","equal_to":"o igual a"}},"more_information":"Más información"},"metrics":{"title":"No hay medidas enlazadas todavía","header":"Medidas","add_or_remove":"Agregar/quitar","description_html":"Las medidas son mediciones cuantificables que se usan para seguir, monitorear y evaluar {{targetTerm}}. Puede enlazar Medidas a un {{targetTerm}} para ayudar a informar la evaluación.","start_linking":"Enlazar medidas","done_editing":"Terminado","edit_metrics":"Editar medidas","view_data":"Ver datos","learn_more":{"label":"Obtener más información."},"link_table":{"title":"Seleccione las medidas a enlazar","search_placeholder":"Buscar medidas","no_metrics_available":"No hay medidas disponibles para enlazar","no_metrics_available_description":"Las medidas son mediciones cuantificables que se usan para seguir, monitorear y evaluar {{targetTerm}}. Una vez que haya creado una medida, puede enlazarla con un {{targetTerm}}.","unlink_confirmation_button":"Desenlazar y guardar cambios","save":"Guardar","cancel":"Cancelar","headers":{"metric":"Medida","table":"Tabla","collection":"Colección"}},"updated_successfully":"Las medidas se actualizaron con éxito","updated_failed":"El registro en el que está trabajando ha sido modificado por otro usuario. Los cambios realizados no se guardaron, vuelva a intentarlo.","linked_metric":{"not_found":"{{name}} se ha eliminado de Resultados y ya no está disponible.","insufficient_data":"No hay suficientes datos para calcular {{name}} en la aplicación Resultados.","no_response":"No podemos cargar Medidas. Actualice la página para volver a intentarlo.","unlink_metric_button":"Desenlazar medida","unlink_metric_header":"¿Desenlazar medidas?","unlink_metric_body":"La desvinculación de esta medida quitará permanentemente los controladores de evaluación asociados.","archived_html":"Esta medida es de una <a href=\"{{collection_url}}\" target=\"_blank\" rel=\"noreferrer noopener\">colección archivada <i class=\"acl-i-arrow-up-b\"></i></a> y es de solo lectura. No se pueden agregar ni modificar datos."},"add_description":"+ Agregue una descripción para dar el contexto de la medida...","formatting":{"blank":"(en blanco)","date":{"default":"D MMM YYYY"},"time":{"default":"hh:mm:ss A","error":"hora desconocida"},"datetime":{"default":"D MMM YYYY hh:mm:ss A"},"numeric":{"abbreviations":{"thousand":"k","million":"mm","billion":"b","trillion":"t"}},"logical":{"true":"T","false":"F"},"labels":{"uniques":"Valores únicos","blanks":"Blancos","percent":"% del total","count":"Recuento","positives":"Positivos","negatives":"Negativos","zeros":"Ceros","total":"Total","average":"Promedio","lowest":"Más bajo","highest":"Más alto","standard_deviation":"Desviación estándar"},"sparkline":{"axis_date":{"day":"DD MMM YYYY","month":"MMM YYYY","quarter":"[T]Q, YYYY","year":"YYYY"}}},"sparkline":{"reset_zoom":"Restablecer el zoom","reset_zoom_tooltip":"Restablecer el nivel de zoom"},"indicator":{"empty":{"no_sparkline_data":"No hay datos suficientes para generar un minigráfico.","no_preview_data":"No hay datos suficientes para calcular esta medida. Intente cambiar los filtros o agregar más datos para calcular la medida."}}},"global_navigation":{"navigation_items":{"logo":"Volver a Launchpad","app_switcher":"Cambiar aplicaciones","announcer":"Anuncios","helper":"Ayuda y soporte","user":"Inició sesión: {{username}}","user_with_customer":"{{username}} {{customerName}}","sign_in":"Iniciar sesión"},"apps":{"academy":"Academia","community":"Comunidad","projects":"Proyectos","results":"Resultados","storyboards":"Storyboards","mission_control":"Control de la misión","risks":"Estrategia","reports":"Reportes","launchpad":"Launchpad","robots":"Robots","frameworks":"Marcos","compliance_maps":"Mapas de cumplimiento","assurance_plans":"Planes de aseguramiento","project_scheduler":"Programador","issue_tracker":"Rastreador de asuntos","task_tracker":"Rastreador de tareas","project_timesheets":"Planillas de horas","dashboard":"Tablero de mando de {{module}}","master_library":"Biblioteca maestra"},"app_sections":{"setup":"Configuración","workspace":"Área de trabajo","automation":"Automatización"},"user":{"my_profile":"Mi perfil","log_out":"Finalizar la sesión"},"helper":{"help_docs":"Documentos de ayuda","support":"Soporte"},"skip_button":"Ir al contenido principal","logo":"logotipo","other":"Otro","section":"sección"},"contacts_dropdown":{"contacts":"Contactos","custom_value_a11y":"Campo de texto {{nameFieldLabel}}","custom_value_enter":"Agregue {{customValue}} como {{nameFieldLabel}} e ingrese manualmente una dirección de correo electrónico.","select_placeholder":"Especifique un usuario...","search_a11y":"Buscar usuario o contacto. Si no hay resultados de búsqueda, utilice el valor de búsqueda como nombre de {{nameFieldLabel}}","search_placeholder":"Busque usuarios o ingrese un nuevo nombre...","email_address":"Dirección de correo electrónico","email_address_error":"La dirección de correo electrónico debe ser válida","users":"Usuarios","contacts_error":"Su libreta de contactos no se cargó."},"resource_sharing":{"loading_collaborators":"Cargando...","add_collaborators_search_placeholder":"Buscar grupos o individuos...","manage_collaborators":"Administrar colaboradores","close":"Cerrar","disabled":"Desactivado","disabled_a11y_text":"Grupo desactivado","disabled_group_tooltip":"Este grupo <strong>no tiene acceso</strong> porque el grupo ha sido desactivado en Launchpad. Los administradores del sistema pueden reactivar el grupo.","add_collaborators":"Agregar colaboradores","add_collaborators_loading_tooltip":"Por favor, espere hasta que se cargue la lista de personas.","individuals":"Personas","individuals_section_tooltip_button":"Información sobre herramientas de la sección Personas","individuals_section_tooltip":"El acceso individual debe ser igual o superior al acceso de grupo asignado. <a href=\"{{url}}\" target=\"_blank\" rel=\"noopener noreferrer\">Obtener más información</a>.","no_results_found":"No se han encontrado resultados","show_more":"Mostrar más","remove":"Quitar","collaborators_widget":{"add":"Agregar","manage":"Gestionar","view":"Ver","more_users_tooltip":"{{remaining_users}} otros"},"side_panel":{"cancel":"Cancelar","groups_count":"{{count}} grupo","groups_count_plural":"{{count}} grupos","individuals_count":"{{count}} individuo","individuals_count_plural":"{{count}} individuos","title":"Compartir ‘{{resource_name}}’","save":"Guardar"},"groups":"Grupos","group_members_count":"({{count}} miembro)","group_members_count_plural":"({{count}} miembros)","disabled_role":"(desactivado)","no_access":"Sin acceso","default":"Predeterminado","default_a11y_text":"Grupo predeterminado","success_message":"{{resource_name}} fue actualizado con éxito.","error_message":"Algo salió mal. Por favor, actualice la página para volver a intentarlo. Si el problema persiste, comuníquese con nuestro equipo de soporte."}}}}

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

module.exports = {"fr":{"translation":{"edit_conflict":{"header":"Modifier le conflit","description":"Cet enregistrement a changé pendant que vous étiez en train de le modifier :","notice":"Ce(tte) {{term}} a changé pendant que vous étiez en train d'y apporter des modifications.","options":{"save_your_edit":"Pour sauvegarder votre modification, copiez le texte à partir de l'éditeur vers votre presse-papiers\nà l'aide du bouton droit de votre souris. Lorsque vous actualisez l'écran ou que vous cliquez sur Sauvegarder les modifications,\nle nouvel enregistrement est chargé.\nIl vous faudra fusionner manuellement votre texte avec le nouvel enregistrement.\n","discard_your_changes":"Pour abandonner vos modifications et charger le nouvel enregistrement,\nactualisez simplement l'écran ou cliquez sr le bouton Sauvegarder.\n","save_changes":"Pour enregistrer vos modifications, copiez le texte dans un autre programme,\nactualisez votre navigateur ou cliquez sur Enregistrer, puis fusionnez manuellement vos modifications.\n","discard_changes":"Pour abandonner vos modifications, actualisez votre navigateur."}},"delete_conflict":{"header":"Supprimer le conflit","notice":"Ce(tte) {{term}} a été supprimé(e) et n'est plus disponible.","options":{"save_changes":"Pour enregistrer vos modifications, copiez le texte dans un autre programme,\npuis saisissez les informations dans un nouveau formulaire %{term}.\n","discard_changes":"Pour abandonner vos modifications, fermez le formulaire et actualisez votre navigateur."}},"assessment_drivers":{"notifications":{"assessment_disabled":"Ce pilote d'évaluation est actuellement désactivé."},"activerecord":{"errors":{"messages":{"assessment_driver":{"unreachable":"Un problème s'est produit pendant l'enregistrement du pilote d'évaluation, veuillez réessayer.","metric_deleted":"{{name}} a été supprimé de l'application Résultats et n'est plus disponible.","targetable_field_changed":"Le barème pour {{name}} a été modifié. Examinez et activez à nouveau ce pilote d'évaluation.","metric_updated":"La configuration de {{name}} a été modifiée dans l'application Résultats. Examinez et activez à nouveau ce pilote d'évaluation.","insufficient_data":"Il n'y a pas assez de données pour calculer {{name}} dans l'application Résultats.","invalid_data":"La valeur pour {{name}} est {{value}} et ne peut pas être correctement traitée par le pilote d'évaluation.","saved_failed":"Un problème s'est produit avec le serveur et nous n'avons pas pu enregistré vos modifications, essayez à nouveau.","no_response":"Nous n'avons pas pu charger les mesures."}}}},"success_saving":"L'évaluation pour {{target}} {{targetableField}} a été correctement automatisée.","bubbly_header":"Automatisez vos évaluations pour {{target_term}}","bubbly_content_html":"Les pilotes d'évaluation vous permettent de tenir à jour vos évaluations, en temps réel. Utilisez des plages de mesures pré-définies pour évaluer {{target_term}} et avertir les intervenants clés en cas de modifications. <a target='_blank' rel=\"noopener noreferrer\" class='bubbly__content__link' href=\"{{url}}\">En savoir plus.</a>","bubbly_footer":"Ne plus afficher cette astuce.","save":"Enregistrer","cancel":"Annuler","enable":"Activer le pilote d'évaluation","delete":"Supprimer","delete_popover":{"title":"Supprimer le pilote d'évaluation ?","description":"Vous ne pourrez plus accéder à cet élément ni le restaurer."},"tour":{"description":{"step_one":"Définissez les conditions qui doivent se produire pour l'évaluation de {{target_term}} afin de permettre la mise à jour automatique avec le score indiqué.","step_two":"Pendant que vous saisissez les valeurs dans la colonne de droite, la colonne de gauche est automatiquement renseignée avec la valeur séquentielle suivante."},"navigation":{"back":"Retour","close":"Fermer","done":"Terminé","next":"Suivant"}},"title":{"new":"Nouveau pilote d'évaluation","edit":"Modifier le pilote d'évaluation"},"dropdowns":{"entity":"Entité","process":"Processus","metric":"Mesure","tooltip":"Désactiver le pilote d'évaluation pour mettre en suspens l'évaluation automatisée de {{target_term}}.","help_icon_text_risk":"Seuls les risques ayant une mesure liée peuvent être sélectionnés.","automated":"%{name} (jeu d'automatisation)","placerholder_entity":"Sélectionnez un(e) %{operating_segment}...","placeholder_metric":"Sélectionner une mesure..."},"metric_ranges":{"errors":{"format_error":"Seuls les chiffres sont valides.","range_error":"Les plages ne peuvent pas se chevaucher."},"dropdown":{"less_than":"inférieur à","greater_than":"supérieur à","equal_to":"ou égal à"}},"more_information":"Plus d'informations"},"metrics":{"title":"Aucune mesure encore liée","header":"Mesures","add_or_remove":"Ajouter/Supprimer","description_html":"Les mesures sont des relevés quantifiables qui permettent de suivre, surveiller et évaluer {{targetTerm}}. Vous pouvez lier les mesures avec {{targetTerm}} pour simplifier la compréhension de l'évaluation.","start_linking":"Lier les mesures","done_editing":"Terminé","edit_metrics":"Modifier les mesures","view_data":"Voir les données","learn_more":{"label":"En savoir plus."},"link_table":{"title":"Sélectionner des mesures à lier","search_placeholder":"Rechercher des mesures","no_metrics_available":"Pas de mesures disponibles pour le lien","no_metrics_available_description":"Les mesures sont des relevés quantifiables qui permettent de suivre, surveiller et évaluer {{targetTerm}}. Une fois que vous avez créé une mesure, vous pouvez la lier à un {{targetTerm}}.","unlink_confirmation_button":"Supprimer le lien et enregistrer les modifications","save":"Enregistrer","cancel":"Annuler","headers":{"metric":"Mesure","table":"Table","collection":"Collection"}},"updated_successfully":"Mesures correctement mises à jour","updated_failed":"Un autre utilisateur a modifié l'enregistrement sur lequel vous travaillez. Les modifications que vous avez apportées n'ont pas été enregistrées, essayez à nouveau.","linked_metric":{"not_found":"{{name}} a été supprimé de Résultats et n'est plus disponible.","insufficient_data":"Il n'y a pas assez de données pour calculer {{name}} dans l'application Résultats.","no_response":"Nous n'avons pas pu charger les mesures. Rafraîchissez la page pour essayer à nouveau.","unlink_metric_button":"Annuler le lien de la mesure","unlink_metric_header":"Annuler le lien des mesures ?","unlink_metric_body":"L'annulation du lien de cette mesure supprime de manière définitive tout pilote d'évaluation associé.","archived_html":"Cette mesure provient d'une <a href=\"{{collection_url}}\" target=\"_blank\" rel=\"noreferrer noopener\">collection archivée <i class=\"acl-i-arrow-up-b\"></i></a> et est en lecture seule. Impossible d'ajouter ou de modifier des données."},"add_description":"+ Ajouter une description pour spécifier le contexte de la mesure...","formatting":{"blank":"(vide)","date":{"default":"D MMM YYYY"},"time":{"default":"HH:mm:ss","error":"heure inconnue"},"datetime":{"default":"D MMM YYYY HH:mm:ss"},"numeric":{"abbreviations":{"thousand":"k","million":"M","billion":"Md(s)","trillion":"T"}},"logical":{"true":"T","false":"F"},"labels":{"uniques":"Valeurs uniques","blanks":"Vides","percent":"% du total","count":"Compte","positives":"Positifs","negatives":"Négatifs","zeros":"Zéros","total":"Total","average":"Moyenne","lowest":"Plus bas","highest":"Plus élevé","standard_deviation":"Ecart-Type"},"sparkline":{"axis_date":{"day":"DD MMM YYYY","month":"MMM YYYY","quarter":"[T]Q, YYYY","year":"YYYY"}}},"sparkline":{"reset_zoom":"Réinitialiser le zoom","reset_zoom_tooltip":"Réinitialiser le niveau de zoom"},"indicator":{"empty":{"no_sparkline_data":"Le nombre de données est insuffisant pour générer un graphique sparkline.","no_preview_data":"Le nombre de données est insuffisant pour calculer cette mesure. Essayez de changer les filtres ou d'ajouter plus de données pour calculer la mesure."}}},"global_navigation":{"navigation_items":{"logo":"Retour vers la Barre de lancement","app_switcher":"Basculer d'une appli à l'autre","announcer":"Annonces","helper":"Aide et Assistance","user":"Connecté(e) : {{username}}","user_with_customer":"{{username}} {{customerName}}","sign_in":"Connexion"},"apps":{"academy":"Académie","community":"Communauté","projects":"Projets","results":"Résultats","storyboards":"Storyboards","mission_control":"Suivi des contrôles","risks":"Stratégie","reports":"Rapports","launchpad":"Barre de lancement","robots":"Robots","frameworks":"Cadres","compliance_maps":"Cartes de conformité","assurance_plans":"Plans d'assurance","project_scheduler":"Planificateur","issue_tracker":"Outil de suivi des problèmes","task_tracker":"Outil de suivi des tâches","project_timesheets":"Relevés des temps","dashboard":"Tableau de bord pour {{module}}","master_library":"Bibliothèque de base"},"app_sections":{"setup":"Configuration","workspace":"Environnement de travail","automation":"Automatisation"},"user":{"my_profile":"Mon profil","log_out":"Déconnexion"},"helper":{"help_docs":"Documentation d'aide","support":"Assistance"},"skip_button":"Passer au contenu principal","logo":"logo","other":"Autres","section":"section"},"contacts_dropdown":{"contacts":"Contacts","custom_value_a11y":"Champ de texte {{nameFieldLabel}}","custom_value_enter":"Ajoutez {{customValue}} en tant que {{nameFieldLabel}} et saisissez manuellement une adresse e-mail.","select_placeholder":"Indiquez un utilisateur...","search_a11y":"Recherchez l'utilisateur ou le contact. Si vous n'obtenez aucun résultat, utilisez alors la valeur de recherche comme le nom pour {{nameFieldLabel}}","search_placeholder":"Rechercher des utilisateurs ou saisir un nouveau nom...","email_address":"Adresse e-mail","email_address_error":"L'adresse e-mail doit être valide","users":"Utilisateurs","contacts_error":"Votre carnet de contacts n'a pas été chargé."},"resource_sharing":{"loading_collaborators":"Chargement...","add_collaborators_search_placeholder":"Rechercher des groupes ou des individus...","manage_collaborators":"Gérer des collaborateurs","close":"Fermer","disabled":"Désactivé","disabled_a11y_text":"Groupe désactivé","disabled_group_tooltip":"Ce groupe <strong>n'a aucun accès</strong> car le groupe a été désactivé dans la barre de lancement. Les admins système peuvent réactiver le groupe.","add_collaborators":"Ajouter des collaborateurs","add_collaborators_loading_tooltip":"Veuillez patienter jusqu'à ce que la liste des individus soit chargée.","individuals":"Personnes","individuals_section_tooltip_button":"Info-bulle Section personnes","individuals_section_tooltip":"L'accès individuel doit être égal ou supérieur à l'accès de groupe affecté. <a href=\"{{url}}\" target=\"_blank\" rel=\"noopener noreferrer\">En savoir plus</a>.","no_results_found":"Aucun résultat trouvé","show_more":"Afficher plus","remove":"Supprimer","collaborators_widget":{"add":"Ajouter","manage":"Gérer","view":"Voir","more_users_tooltip":"{{remaining_users}} autres"},"side_panel":{"cancel":"Annuler","groups_count":"{{count}} groupe","groups_count_plural":"{{count}} groupes","individuals_count":"{{count}} individu","individuals_count_plural":"{{count}} individus","title":"Partager ‘{{resource_name}}’","save":"Enregistrer"},"groups":"Groupes","group_members_count":"({{count}} membre)","group_members_count_plural":"({{count}} membres)","disabled_role":"(désactivé)","no_access":"Aucun accès","default":"Par défaut","default_a11y_text":"Groupe par défaut","success_message":"{{resource_name}} a été mis à jour.","error_message":"Un incident est survenu. Veuillez rafraîchir la page pour essayer à nouveau. Si le problème persiste, contactez notre équipe de l'assistance."}}}}

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

module.exports = {"ja":{"translation":{"edit_conflict":{"header":"編集による競合","description":"編集中に変更されたレコード:","notice":"編集中にこの{{term}}が変更されました。","options":{"save_your_edit":"編集内容を保存するには、マウスの右ボタンをクリックしてエディター上のテキストを\nクリップボードにコピーします。画面を更新するか、または [変更の保存] をクリックすると、\n新しいレコードが読み込まれます。\n新しいレコードにテキストを手動でマージする必要があります。\n","discard_your_changes":"変更を破棄して新しいレコードを読み込む場合は、\n単に画面を更新するか、または [保存] ボタンをクリックします。\n","save_changes":"変更を保存するには、別のプログラムにテキストをコピーし、\nブラウザーを最新の情報に更新するか、［保存］をクリックし、変更を手動でマージします。\n","discard_changes":"変更を破棄するには、ご利用のブラウザーを最新の情報に更新します。"}},"delete_conflict":{"header":"重複の削除","notice":"この{{term}}が削除されているため、利用できません。","options":{"save_changes":"変更を保存するには、別のプログラムにテキストをコピーし、\nそこで新しい%{term}フォームにこの情報を入力します。\n","discard_changes":"変更を破棄するには、フォームを閉じ、ご利用のブラウザーを最新の情報に更新します。"}},"assessment_drivers":{"notifications":{"assessment_disabled":"この評価ドライバーは現在無効です。"},"activerecord":{"errors":{"messages":{"assessment_driver":{"unreachable":"評価ドライバーを保存中に問題が発生しました、もう一度お試しください。","metric_deleted":"{{name}}はリザルトアプリから削除されているため利用できません。","targetable_field_changed":"{{name}}のスケールが変更されました。この評価ドライバーをレビューし、もう一度有効にします。","metric_updated":"{{name}}の設定はリザルトアプリで変更されています。この評価ドライバーをもう一度レビューし、有効にします。","insufficient_data":"リザルトアプリで{{name}}を計算するための十分なデータがありません。","invalid_data":"{{name}}の値は {{value}} であり、評価ドライバーで適切に処理できません。","saved_failed":"サーバーに問題が発生し、変更を保存できませんでした。もう一度お試しください。","no_response":"メトリクスを読み込めません。"}}}},"success_saving":"{{target}} {{targetableField}}評価は正常に自動化されました。","bubbly_header":"{{target_term}}評価を自動化","bubbly_content_html":"評価ドライバーにより、リアルタイムで評価を最新の状態に維持できます。事前に定義されたメトリクスの範囲を使用して{{target_term}}を評価し、変更が発生したら主な関係者に通知します。<a target='_blank' rel=\"noopener noreferrer\" class='bubbly__content__link' href=\"{{url}}\">詳細を表示。</a>","bubbly_footer":"今後、このメッセージを表示しない","save":"保存","cancel":"キャンセル","enable":"評価ドライバーを有効化","delete":"削除","delete_popover":{"title":"評価ドライバーを削除しますか?","description":"この項目は、アクセスすることも復元することもできなくなります。"},"tour":{"description":{"step_one":"{{target_term}}評価で発生する必要のある状況を定義して、指定したスコアに自動的に更新されるようにしてください。","step_two":"右の列に値を入力するとおりに、左の列が連続する次の値で自動入力されます。"},"navigation":{"back":"戻る","close":"閉じる","done":"完了","next":"次へ"}},"title":{"new":"新しい評価ドライバー","edit":"評価ドライバーを編集"},"dropdowns":{"entity":"エンティティ","process":"プロセス","metric":"メトリクス","tooltip":"評価ドライバーを無効にして、自動化された{{target_term}}評価を一時停止します。","help_icon_text_risk":"メトリクスがリンクされているリスクのみを選択できます。","automated":"%{name} (オートメーションの設定)","placerholder_entity":"%{operating_segment}を選択...","placeholder_metric":"メトリクスを選択..."},"metric_ranges":{"errors":{"format_error":"数字のみ有効です。","range_error":"範囲は重複できません。"},"dropdown":{"less_than":"次の値未満:","greater_than":"次の値より大きい:","equal_to":"または次の値と等しい:"}},"more_information":"詳しい情報"},"metrics":{"title":"メトリクスがまだリンクされていません","header":"メトリクス","add_or_remove":"追加/削除","description_html":"メトリクスは、{{targetTerm}}の追跡、監視、および評価するために使用される、定量化できる評価基準です。評価を通知できるように、メトリクスを{{targetTerm}}にリンクさせることができます。","start_linking":"メトリクスをリンクする","done_editing":"完了","edit_metrics":"メトリクスを編集","view_data":"データを表示","learn_more":{"label":"詳細を表示。"},"link_table":{"title":"リンクするメトリクスを選択","search_placeholder":"メトリクスを検索","no_metrics_available":"リンクに利用できるメトリクスがありません","no_metrics_available_description":"メトリクスは、{{targetTerm}}の追跡、監視、および評価するために使用される、定量化できる評価基準です。メトリクスを作成したら、{{targetTerm}}にこのメトリクスをリンクさせることができます。","unlink_confirmation_button":"変更へのリンク解除と保存","save":"保存","cancel":"キャンセル","headers":{"metric":"メトリクス","table":"テーブル","collection":"コレクション"}},"updated_successfully":"メトリクスが正常に更新されました","updated_failed":"作業中のレコードは、別のユーザーによって修正されました。変更内容は保存されませんでした。もう一度お試しください。","linked_metric":{"not_found":"{{name}}はリザルトから削除されているため利用できません。","insufficient_data":"リザルトアプリで{{name}}を計算するための十分なデータがありません。","no_response":"メトリクスを読み込めません。このページを更新してもう一度実行してください。","unlink_metric_button":"メトリクスをリンク解除","unlink_metric_header":"メトリクスをリンク解除?","unlink_metric_body":"このメトリクスをリンク解除すると、関連する評価ドライバーはすべて完全に削除されます。","archived_html":"このメトリクスは<a href=\"{{collection_url}}\" target=\"_blank\" rel=\"noreferrer noopener\">アーカイブ済みコレクション<i class=\"acl-i-arrow-up-b\"></i></a>からのものであり、読み取り専用です。データは追加または変更できません。"},"add_description":"説明を［+ 追加］し、メトリクスの背景を説明します...","formatting":{"blank":"(空白)","date":{"default":"YYYY/MM/DD"},"time":{"default":"HH:mm:ss","error":"不明な時間"},"datetime":{"default":"YYYY/MM/DD HH:mm:ss"},"numeric":{"abbreviations":{"thousand":"千","million":"百万","billion":"十億","trillion":"兆"}},"logical":{"true":"T","false":"F"},"labels":{"uniques":"一意の値","blanks":"空白","percent":"合計の %","count":"カウント","positives":"正数","negatives":"負数","zeros":"ゼロ","total":"合計","average":"平均","lowest":"最低値","highest":"最高値","standard_deviation":"標準偏差"},"sparkline":{"axis_date":{"day":"YYYY 年 M 月 D 日","month":"YYYY 年 M 月","quarter":"YYYY 年第 [Q]Q 四半期","year":"YYYY 年"}}},"sparkline":{"reset_zoom":"ズームをリセット","reset_zoom_tooltip":"ズーム レベルをリセット"},"indicator":{"empty":{"no_sparkline_data":"スパーク ラインを生成できるだけのデータがありません。","no_preview_data":"このメトリクスを計算するための十分なデータがありません。メトリクスを計算するには、フィルターを変更するか、その他のデータを追加してください。"}}},"global_navigation":{"navigation_items":{"logo":"Launchpad に戻る","app_switcher":"アプリを切り替える","announcer":"発表","helper":"ヘルプとサポート","user":"サインイン: {{username}}","user_with_customer":"{{username}} {{customerName}}","sign_in":"サインイン"},"apps":{"academy":"アカデミー","community":"コミュニティ","projects":"プロジェクト","results":"リザルト","storyboards":"ストーリーボード","mission_control":"ミッション コントロール","risks":"ストラテジー","reports":"レポート","launchpad":"Launchpad","robots":"ロボット","frameworks":"フレームワーク","compliance_maps":"コンプライアンス マップ","assurance_plans":"保証計画","project_scheduler":"スケジューラ","issue_tracker":"問題の追跡ツール","task_tracker":"タスクの追跡ツール","project_timesheets":"タイムシート","dashboard":"{{module}}ダッシュボード","master_library":"マスター ライブラリ"},"app_sections":{"setup":"セットアップ","workspace":"ワークスペース","automation":"自動化"},"user":{"my_profile":"マイ プロファイル","log_out":"ログアウト"},"helper":{"help_docs":"ヘルプ ドキュメント","support":"サポート"},"skip_button":"メイン コンテンツまでスキップ","logo":"ロゴ","other":"その他","section":"セクション"},"contacts_dropdown":{"contacts":"連絡先","custom_value_a11y":"{{nameFieldLabel}} テキスト フィールド","custom_value_enter":"{{nameFieldLabel}}として{{customValue}}を追加し、電子メールアドレスを手動で入力します。","select_placeholder":"ユーザーを指定します...","search_a11y":"ユーザーまたは連絡先を検索します。検索結果がない場合は、{{nameFieldLabel}} 名として検索値を使用します。","search_placeholder":"ユーザーを検索するか、新しい名前を入力します...","email_address":"電子メール アドレス","email_address_error":"電子メール アドレスは有効でなくてはなりません","users":"ユーザー","contacts_error":"ご利用のアドレス帳を読み込めませんでした。"},"resource_sharing":{"loading_collaborators":"読み込み中...","add_collaborators_search_placeholder":"グループまたは個人を検索...","manage_collaborators":"コラボレーターを管理する","close":"閉じる","disabled":"無効","disabled_a11y_text":"無効化済みグループ","disabled_group_tooltip":"Launchpad でグループが無効になっているため、このグループに<strong>アクセスできません</strong>。システム管理者は、グループを再有効化できます。","add_collaborators":"コラボレーターを追加する","add_collaborators_loading_tooltip":"個人の一覧が読み込まれるまでお待ちください。","individuals":"個人","individuals_section_tooltip_button":"個人のセクション ツール チップ","individuals_section_tooltip":"個人のアクセス権は、割り当てられたグループ アクセス権と同等以上でなければなりません。<a href=\"{{url}}\" target=\"_blank\" rel=\"noopener noreferrer\">詳細を表示</a>。","no_results_found":"結果が見つかりません","show_more":"詳しく表示","remove":"削除","collaborators_widget":{"add":"追加","manage":"管理","view":"表示","more_users_tooltip":"{{remaining_users}} 他"},"side_panel":{"cancel":"キャンセル","groups_count":"{{count}} グループ","groups_count_plural":"{{count}} グループ","individuals_count":"{{count}} 個人","individuals_count_plural":"{{count}} 個人","title":"‘{{resource_name}}’ を共有する","save":"保存"},"groups":"グループ","group_members_count":"({{count}} メンバー)","group_members_count_plural":"({{count}} メンバー)","disabled_role":"(無効化済み)","no_access":"アクセス権なし","default":"既定","default_a11y_text":"既定のグループ","success_message":"{{resource_name}} は正常に更新されました。","error_message":"問題が発生しました。このページを更新してもう一度実行してください。問題が解決しない場合は、サポート チームにお問い合わせください。"}}}}

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

module.exports = {"pt":{"translation":{"edit_conflict":{"header":"Editar Conflito","description":"Este registro foi alterado enquanto você editava:","notice":"Este(a) {{term}} mudou enquanto você estava editando.","options":{"save_your_edit":"Para salvar sua edição, copie o texto do editor para sua prancheta\nutilizando o botão direto do seu mouse. Quando você atualizar a tela ou clicar em Salvar Alterações,\no novo registro será carregado.\nVocê precisará fundir manualmente o seu texto ao novo registro.\n","discard_your_changes":"Para descartar suas mudanças e carregar o novo registro,\napenas atualize a tela ou clique no botão Salvar.\n","save_changes":"Para salvar suas alterações, copie o texto para outro programa,\natualize seu navegador ou clique em Salvar e mescle manualmente suas alterações.\n","discard_changes":"Para descartar suas alterações, atualize o navegador."}},"delete_conflict":{"header":"Excluir Conflito","notice":"Este(a) {{term}} foi excluído(a) e não está mais disponível.","options":{"save_changes":"Para salvar suas alterações, copie o texto para outro programa,\ne insira as informações em um novo formulário de %{term}.\n","discard_changes":"Para descartar suas alterações, feche o formulário e atualize o navegador."}},"assessment_drivers":{"notifications":{"assessment_disabled":"Este Driver de Avaliação está desativado no momento."},"activerecord":{"errors":{"messages":{"assessment_driver":{"unreachable":"Ocorreu um problema ao salvar o Driver de Avaliação, tente novamente.","metric_deleted":"{{name}} foi excluído(a) do aplicativo Resultados e não está mais disponível.","targetable_field_changed":"A escala para {{name}} foi alterada. Revise e habilite o Driver de Avaliação novamente.","metric_updated":"A configuração de {{name}} foi alterada no aplicativo Resultados. Revise e ative o Driver de Avaliação novamente.","insufficient_data":"Não há dados suficientes para calcular {{name}} no aplicativo Resultados.","invalid_data":"O valor para {{name}} é {{value}} e não pode ser adequadamente processado pelo Driver de Avaliação.","saved_failed":"Houve um problema com o servidor e não foi possível salvar suas alterações. Tente novamente.","no_response":"Não foi possível carregar as Métricas."}}}},"success_saving":"Classificação de {{targetableField}} de {{target}} automatizada com sucesso.","bubbly_header":"Automatize suas avaliações de ({target_term})","bubbly_content_html":"Os Drivers de Avaliação permitem que você mantenha suas avaliações atualizadas, em tempo real. Use intervalos de métricas para avaliar seu ({target_term}) e notificar as principais partes interessadas quando ocorrerem mudanças. <a target='_blank' rel=\"noopener noreferrer\" class='bubbly__content__link' href=\"{{url}}\">Saiba mais.</a>","bubbly_footer":"Não exibir esta dica novamente.","save":"Salvar","cancel":"Cancelar","enable":"Ativar Driver de Avaliação","delete":"Excluir","delete_popover":{"title":"Excluir Driver de Avaliação?","description":"Você não poderá acessar nem restaurar este item."},"tour":{"description":{"step_one":"Defina as condições que precisam ocorrer para que a avaliação de risco seja automaticamente atualizada para a pontuação especificada.","step_two":"Ao inserir valores na coluna à direita, a coluna à esquerda é preenchida automaticamente com o próximo valor sequencial."},"navigation":{"back":"Voltar","close":"Fechar","done":"Concluído","next":"Próximo"}},"title":{"new":"Novo Driver de Avaliação","edit":"Editar Driver de Avaliação"},"dropdowns":{"entity":"Entidade","process":"Processo","metric":"Métrica","tooltip":"Desative o Driver de Avaliação para pausar a avaliação de {{target_term}} automatizada.","help_icon_text_risk":"Apenas riscos com Métricas vinculadas podem ser selecionados.","automated":"%{name} (ajuste automático)","placerholder_entity":"Selecione um(a) %{operating_segment}...","placeholder_metric":"Selecione uma Métrica..."},"metric_ranges":{"errors":{"format_error":"Apenas números são válidos.","range_error":"Os intervalos não pode se sobrepor."},"dropdown":{"less_than":"menor que","greater_than":"maior que","equal_to":"ou igual a"}},"more_information":"Mais informações"},"metrics":{"title":"Nenhuma Métrica Vinculada Ainda","header":"Métricas","add_or_remove":"Adicionar/Remover","description_html":"Métricas são medidas quantificáveis usadas para rastrear, monitorar e avaliar {{targetTerm}}. Você pode vincular Métricas a um {{targetTerm}} para ajudar a informar a avaliação de risco.","start_linking":"Vincular Métricas","done_editing":"Concluído","edit_metrics":"Editar Métricas","view_data":"Exibir Dados","learn_more":{"label":"Saiba mais."},"link_table":{"title":"Selecionar Métricas a vincular","search_placeholder":"Pesquisar Métricas","no_metrics_available":"Não há Métricas disponíveis para vincular","no_metrics_available_description":"Métricas são medidas quantificáveis usadas para rastrear, monitorar e avaliar ({targetTerm}). Depois de criar uma Métrica, você pode vinculá-la a um {{targetTerm}}.","unlink_confirmation_button":"Desvincular e salvar alterações","save":"Salvar","cancel":"Cancelar","headers":{"metric":"Métrica","table":"Tabela","collection":"Coleção"}},"updated_successfully":"Métricas atualizadas com sucesso","updated_failed":"O registro em que você está trabalhando foi modificado por outro usuário. As alterações feitas não foram salvas, tente novamente.","linked_metric":{"not_found":"{{name}} foi excluído(a) do Resultados e não está mais disponível.","insufficient_data":"Não há dados suficientes para calcular {{name}} no aplicativo Resultados.","no_response":"Não foi possível carregar as Métricas. Atualize a página e tente novamente.","unlink_metric_button":"Desvincular métrica","unlink_metric_header":"Desvincular Métricas?","unlink_metric_body":"Desvincular essa Métrica removerá permanentemente todos os Drivers de Avaliação associados.","archived_html":"Essa métrica é de uma <a href=\"{{collection_url}}\" target=\"_blank\" rel=\"noreferrer noopener\">coleção arquivada <i class=\"acl-i-arrow-up-b\"></i></a> e é somente leitura. Nenhum dado pode ser adicionado ou alterado."},"add_description":"+ Adicionar uma descrição para dar contexto à Métrica...","formatting":{"blank":"(branco)","date":{"default":"D MMM YYYY"},"time":{"default":"HH:mm:ss","error":"hora desconhecida"},"datetime":{"default":"D MMM YYYY HH:mm:ss"},"numeric":{"abbreviations":{"thousand":"mil","million":"mi","billion":"bi","trillion":"tri"}},"logical":{"true":"T","false":"F"},"labels":{"uniques":"Valores únicos","blanks":"Brancos","percent":"% do total","count":"Contagem","positives":"Positivos","negatives":"Negativos","zeros":"Zeros","total":"Total","average":"Média","lowest":"Mais baixo","highest":"Mais alto","standard_deviation":"Desvio Padrão"},"sparkline":{"axis_date":{"day":"DD MMM YYYY","month":"MMM YYYY","quarter":"[T]Q, YYYY","year":"YYYY"}}},"sparkline":{"reset_zoom":"Redefinir zoom","reset_zoom_tooltip":"Redefinir nível de zoom"},"indicator":{"empty":{"no_sparkline_data":"Não há dados suficientes para gerar um minigráfico.","no_preview_data":"Não há dados suficientes para calcular esta métrica. Tente alterar os filtros ou adicionar mais dados para calcular a métrica."}}},"global_navigation":{"navigation_items":{"logo":"Voltar para o Launchpad","app_switcher":"Alternar Aplicativos","announcer":"Lançamentos","helper":"Ajuda e Suporte","user":"Entrou: {{username}}","user_with_customer":"{{username}} {{customerName}}","sign_in":"Entrar"},"apps":{"academy":"Academia","community":"Comunidade","projects":"Projetos","results":"Resultados","storyboards":"Storyboards","mission_control":"Controle da Missão","risks":"Estratégia","reports":"Relatórios","launchpad":"Launchpad","robots":"Robôs","frameworks":"Estruturas","compliance_maps":"Mapas de Conformidade","assurance_plans":"Planos de Garantia","project_scheduler":"Agendador","issue_tracker":"Rastreador de Problemas","task_tracker":"Rastreador de Tarefas","project_timesheets":"Quadros de Horário","dashboard":"Painel do {{module}}","master_library":"Biblioteca Principal"},"app_sections":{"setup":"Configuração","workspace":"Área de trabalho","automation":"Automação"},"user":{"my_profile":"Meu Perfil","log_out":"Efetuar Logout"},"helper":{"help_docs":"Documentos de Ajuda","support":"Suporte"},"skip_button":"Ir para conteúdo principal","logo":"logotipo","other":"Outro","section":"seção"},"contacts_dropdown":{"contacts":"Contatos","custom_value_a11y":"Campo de texto de {{nameFieldLabel}}","custom_value_enter":"Adicionar {{customValue}} como {{nameFieldLabel}} e inserir um endereço de e-mail manualmente.","select_placeholder":"Especificar um usuário...","search_a11y":"Pesquisar usuário ou contato. Se não houver resultados de pesquisa, use o valor de pesquisa como nome de {{nameFieldLabel}}","search_placeholder":"Pesquisar usuários ou inserir novo nome...","email_address":"Endereço de e-mail","email_address_error":"O endereço de e-mail deve ser válido","users":"Usuários","contacts_error":"Sua agenda de contatos não foi carregada."},"resource_sharing":{"loading_collaborators":"Carregando...","add_collaborators_search_placeholder":"Pesquisar grupos ou indivíduos...","manage_collaborators":"Gerenciar colaboradores","close":"Fechar","disabled":"Desabilitado","disabled_a11y_text":"Desativar grupo","disabled_group_tooltip":"Este grupo <strong>não tem acesso</strong> porque foi desativado no Launchpad. Administradores do sistema podem reativar o grupo.","add_collaborators":"Adicionar Colaboradores","add_collaborators_loading_tooltip":"Aguarde até que a lista de indivíduos seja carregada.","individuals":"Indivíduos","individuals_section_tooltip_button":"Kit de Ferramentas da Seção Indivíduos","individuals_section_tooltip":"O acesso individual deve ser igual ou superior ao acesso atribuído ao grupo. <a href=\"{{url}}\" target=\"_blank\" rel=\"noopener noreferrer\">Saiba mais</a>.","no_results_found":"Nenhum resultado encontrado","show_more":"Mostrar mais","remove":"Remover","collaborators_widget":{"add":"Adicionar","manage":"Gerenciar","view":"Exibir","more_users_tooltip":"{{remaining_users}} outros(as)"},"side_panel":{"cancel":"Cancelar","groups_count":"{{count}} grupo","groups_count_plural":"{{count}} grupos","individuals_count":"{{count}} indivíduo","individuals_count_plural":"{{count}} indivíduos","title":"Compartilhar ‘{{resource_name}}’","save":"Salvar"},"groups":"Grupos","group_members_count":"({{count}} membro)","group_members_count_plural":"({{count}} membros)","disabled_role":"(desabilitado)","no_access":"Sem acesso","default":"Padrão","default_a11y_text":"Grupo padrão","success_message":"{{resource_name}} foi atualizado com sucesso.","error_message":"Algo deu errado. Atualize a página e tente novamente. Se o problema persistir, entre em contato com nossa equipe de suporte."}}}}

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

module.exports = {"zh":{"translation":{"edit_conflict":{"header":"编辑冲突","description":"您在编辑时此记录有变化：","notice":"您在编辑时此{{term}}有变化。","options":{"save_your_edit":"要保存您的编辑，\n点击鼠标右键，从编辑器复制文本至您的剪贴板。当您刷新屏幕或点击保存更改时，\n新记录将被加载。\n您将需要手动合并您的文本至新记录。\n","discard_your_changes":"要放弃更改并加载新记录，\n只需刷新屏幕或点击保存按钮。\n","save_changes":"要保存更改，请将文本复制到另一个计划，\n刷新浏览器或单击保存，然后手动合并更改。\n","discard_changes":"若要放弃更改，请刷新您的浏览器。"}},"delete_conflict":{"header":"删除冲突","notice":"此{{term}}已被删除，不再可用。","options":{"save_changes":"要保存更改，请将文本复制到另一个计划，\n并在新的%{term}表单输入信息。\n","discard_changes":"若要放弃更改，请关闭表单并刷新您的浏览器。"}},"assessment_drivers":{"notifications":{"assessment_disabled":"此评估推动器当前被禁用。"},"activerecord":{"errors":{"messages":{"assessment_driver":{"unreachable":"保存评估推动器时出现问题，请重试。","metric_deleted":"{{name}}已被从结果应用程序中删除，不再可用。","targetable_field_changed":"{{name}}的刻度尺已更改。再次查看并启用此评估推动器。","metric_updated":"{{name}}的配置已在结果应用程序中更改。再次查看并启用此评估推动器。","insufficient_data":"没有足够的数据以在结果应用程序中计算{{name}}。","invalid_data":"{{name}}的值是{{value}}，无法由评估推动器正确处理。","saved_failed":"服务器出现问题，我们无法保存您的更改，请重试。","no_response":"我们无法加载度量。"}}}},"success_saving":"{{target}} {{targetableField}}评级成功自动化。","bubbly_header":"自动化您的{{target_term}}评估","bubbly_content_html":"评估推动器允许您实时监控评估。使用预定义的度量范围评估您的{{target_term}}，并在发生变化时通知关键利益相关者。<a target='_blank' rel=\"noopener noreferrer\" class='bubbly__content__link' href=\"{{url}}\">了解详细信息。</a>","bubbly_footer":"不要再显示此提示。","save":"保存","cancel":"取消","enable":"启用评估推动器","delete":"删除","delete_popover":{"title":"删除评估推动器？","description":"您将无法访问或恢复此项。"},"tour":{"description":{"step_one":"定义{{target_term}}评估需要发生的条件，以自动更新到指定的分数。","step_two":"当您在右列中输入值时，左列将自动填充下一个顺序值。"},"navigation":{"back":"返回","close":"关闭","done":"完成","next":"下一步"}},"title":{"new":"新的评估推动器","edit":"编辑评估推动器"},"dropdowns":{"entity":"实体","process":"进程","metric":"度量","tooltip":"禁用评估推动器暂停自动化{{target_term}}评估。","help_icon_text_risk":"只能选择已链接度量的风险。","automated":"%{name}（自动化集）","placerholder_entity":"选择%{operating_segment}…","placeholder_metric":"选择度量…"},"metric_ranges":{"errors":{"format_error":"仅数字有效。","range_error":"范围不能重叠。"},"dropdown":{"less_than":"小于","greater_than":"大于","equal_to":"或等于"}},"more_information":"更多信息"},"metrics":{"title":"尚未链接度量","header":"度量","add_or_remove":"添加/移除","description_html":"度量是用来跟踪、监视和评估{{targetTerm}}的量化指标。您可以链接度量到{{targetTerm}}，以帮助告知评估。","start_linking":"链接度量","done_editing":"完成","edit_metrics":"编辑度量","view_data":"查看数据","learn_more":{"label":"了解详细信息。"},"link_table":{"title":"选择度量以链接","search_placeholder":"搜索度量","no_metrics_available":"没有度量可用于链接","no_metrics_available_description":"度量是用来跟踪、监视和评估{{targetTerm}}的量化指标。一旦创建了度量，您可以把将其链接到{{targetTerm}}。","unlink_confirmation_button":"取消链接并保存更改","save":"保存","cancel":"取消","headers":{"metric":"度量","table":"表","collection":"集合"}},"updated_successfully":"已成功更新度量","updated_failed":"您正在处理的记录已被另一个用户修改。未保存您所做的修改，请重试。","linked_metric":{"not_found":"{{name}}已被从结果应用程序中删除，不再可用。","insufficient_data":"没有足够的数据以在结果应用程序中计算{{name}}。","no_response":"我们无法加载度量。请刷新页面再试一次。","unlink_metric_button":"取消链接度量","unlink_metric_header":"取消链接度量？","unlink_metric_body":"取消链接此度量将永久删除任何相关联的评估推动器。","archived_html":"此度量标准来自<a href=\"{{collection_url}}\" target=\"_blank\" rel=\"noreferrer noopener\">存档集合<i class=\"acl-i-arrow-up-b\"></i></a>，并且是只读的。无法添加或更改任何数据。"},"add_description":"+ 添加描述以提供度量背景…","formatting":{"blank":"（空）","date":{"default":"YYYY年M月D日"},"time":{"default":"ahh:mm:ss","error":"未知的时间"},"datetime":{"default":"YYYY年M月D日 ahh:mm:ss"},"numeric":{"abbreviations":{"thousand":"千","million":"百万","billion":"十亿","trillion":"兆"}},"logical":{"true":"T","false":"F"},"labels":{"uniques":"唯一值","blanks":"空白","percent":"合计百分比","count":"计数","positives":"正","negatives":"负","zeros":"零","total":"合计","average":"平均","lowest":"最低","highest":"最高","standard_deviation":"标准偏差"},"sparkline":{"axis_date":{"day":"YYYY 年 M 月 D 日","month":"YYYY 年 M 月","quarter":"YYYY 年 [Q]Q 季度","year":"YYYY 年"}}},"sparkline":{"reset_zoom":"重置缩放","reset_zoom_tooltip":"重置缩放级别"},"indicator":{"empty":{"no_sparkline_data":"没有足够的数据生成微线图。","no_preview_data":"没有足够的数据来计算此量度。请尝试更改您的过滤器或添加更多数据来计算此量度。"}}},"global_navigation":{"navigation_items":{"logo":"返回到启动面板","app_switcher":"切换应用","announcer":"公告","helper":"帮助和支持","user":"登录：{{username}}","user_with_customer":"{{username}} {{customerName}}","sign_in":"登录"},"apps":{"academy":"学校","community":"社区","projects":"项目","results":"结果","storyboards":"Storyboard","mission_control":"任务控制","risks":"战略","reports":"报告","launchpad":"启动面板","robots":"机器人","frameworks":"框架","compliance_maps":"合规地图","assurance_plans":"保障计划","project_scheduler":"计划器","issue_tracker":"问题跟踪器","task_tracker":"任务跟踪器","project_timesheets":"时间表","dashboard":"{{module}}仪表盘","master_library":"主库"},"app_sections":{"setup":"设置","workspace":"工作空间","automation":"自动化"},"user":{"my_profile":"我的个人资料","log_out":"注销"},"helper":{"help_docs":"帮助文档","support":"支持"},"skip_button":"跳到主要内容","logo":"徽标","other":"其他","section":"部分"},"contacts_dropdown":{"contacts":"联系人","custom_value_a11y":"{{nameFieldLabel}} 文本字段","custom_value_enter":"添加 {{customValue}} 作为 {{nameFieldLabel}} 并手动输入电子邮件地址。","select_placeholder":"指定用户…","search_a11y":"搜索用户或联系人。如果没有搜索结果，则使用搜索值作为{{nameFieldLabel}}名称","search_placeholder":"搜索用户或输入新名称…","email_address":"电子邮件地址","email_address_error":"电子邮件地址应有效","users":"用户","contacts_error":"您的通讯录未加载。"},"resource_sharing":{"loading_collaborators":"正在加载…","add_collaborators_search_placeholder":"搜索组或个人…","manage_collaborators":"管理协作者","close":"关闭","disabled":"已禁用","disabled_a11y_text":"已禁用组","disabled_group_tooltip":"该组<strong>无访问权限</strong>，因为该组已在启动面板中被禁用。系统管理员可以重新启用该组。","add_collaborators":"添加协作者","add_collaborators_loading_tooltip":"请等待加载个人列表。","individuals":"个人","individuals_section_tooltip_button":"个人部分工具提示","individuals_section_tooltip":"个人访问权限必须等于或高于分配的组访问权限。<a href=\"{{url}}\" target=\"_blank\" rel=\"noopener noreferrer\">了解详细信息</a>。","no_results_found":"未找到结果","show_more":"显示更多","remove":"移除","collaborators_widget":{"add":"添加","manage":"管理","view":"查看","more_users_tooltip":"{{remaining_users}} 其他"},"side_panel":{"cancel":"取消","groups_count":"{{count}}个组","groups_count_plural":"{{count}}个组","individuals_count":"{{count}}位个人","individuals_count_plural":"{{count}}位个人","title":"共享‘{{resource_name}}’","save":"保存"},"groups":"组","group_members_count":"（{{count}} 个成员）","group_members_count_plural":"（{{count}} 个成员）","disabled_role":"（已禁用）","no_access":"禁止访问","default":"默认","default_a11y_text":"默认组","success_message":"{{resource_name}}已成功更新。","error_message":"出了些问题。请刷新页面再试一次。如果问题仍然存在，请联系我们的支持团队。"}}}}

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(44);

var assertThisInitialized = __webpack_require__(16);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_i18n__ = __webpack_require__(31);



var defaultLocale = 'en';
var localeObservers = [];

function initNumeralJs(localeCode) {
  try {
    // eslint-disable-next-line
    __WEBPACK_IMPORTED_MODULE_1_numeral___default.a.locale(localeCode, __webpack_require__(224)("./".concat(localeCode)));
    __WEBPACK_IMPORTED_MODULE_1_numeral___default.a.locale(localeCode);
  } catch (e) {
    __WEBPACK_IMPORTED_MODULE_1_numeral___default.a.locale(defaultLocale);
  }

  var abbreviationsOverride = {
    thousand: __WEBPACK_IMPORTED_MODULE_2_i18n_i18n__["a" /* default */].t('metrics.formatting.numeric.abbreviations.thousand'),
    million: __WEBPACK_IMPORTED_MODULE_2_i18n_i18n__["a" /* default */].t('metrics.formatting.numeric.abbreviations.million'),
    billion: __WEBPACK_IMPORTED_MODULE_2_i18n_i18n__["a" /* default */].t('metrics.formatting.numeric.abbreviations.billion'),
    trillion: __WEBPACK_IMPORTED_MODULE_2_i18n_i18n__["a" /* default */].t('metrics.formatting.numeric.abbreviations.trillion')
  }; // eslint-disable-next-line

  for (var key in __WEBPACK_IMPORTED_MODULE_1_numeral___default.a.localeData().abbreviations) {
    __WEBPACK_IMPORTED_MODULE_1_numeral___default.a.localeData().abbreviations[key] = abbreviationsOverride[key];
  }
}

function notifyObservers(localeCode) {
  localeObservers.forEach(function (func) {
    func(localeCode);
  });
}

var i18nFormatter = {
  set locale(locale) {
    this.currentLocale = locale || defaultLocale;
    Object(__WEBPACK_IMPORTED_MODULE_2_i18n_i18n__["a" /* default */])(locale);
    __WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale(locale);
    initNumeralJs(locale);
    notifyObservers(locale);
  },

  get locale() {
    return this.currentLocale;
  },

  addObserver: function addObserver(func) {
    localeObservers.push(func);
  },
  removeObserver: function removeObserver(func) {
    var index = localeObservers.indexOf(func);

    if (index >= 0) {
      localeObservers.splice(index, 1);
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (i18nFormatter);

/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1342);


/***/ }),

/***/ 1342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dateFormatter__ = __webpack_require__(136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DateFormatter", function() { return __WEBPACK_IMPORTED_MODULE_0__dateFormatter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datetimeFormatter__ = __webpack_require__(235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DatetimeFormatter", function() { return __WEBPACK_IMPORTED_MODULE_1__datetimeFormatter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logicalFormatter__ = __webpack_require__(236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LogicalFormatter", function() { return __WEBPACK_IMPORTED_MODULE_2__logicalFormatter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__numberFormatter__ = __webpack_require__(237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NumberFormatter", function() { return __WEBPACK_IMPORTED_MODULE_3__numberFormatter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__percentageFormatter__ = __webpack_require__(238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PercentageFormatter", function() { return __WEBPACK_IMPORTED_MODULE_4__percentageFormatter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tableDataFormatter__ = __webpack_require__(250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TableDataFormatter", function() { return __WEBPACK_IMPORTED_MODULE_5__tableDataFormatter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__timeFormatter__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TimeFormatter", function() { return __WEBPACK_IMPORTED_MODULE_6__timeFormatter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_i18nFormatter__ = __webpack_require__(131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i18nFormatter", function() { return __WEBPACK_IMPORTED_MODULE_7__i18n_i18nFormatter__["a"]; });









/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_i18n__ = __webpack_require__(31);


var DateFormatter = {
  rawFormat: 'YYYY-MM-DD',
  defaultFormat: function defaultFormat() {
    return __WEBPACK_IMPORTED_MODULE_1_i18n_i18n__["a" /* default */].t('metrics.formatting.date.default');
  },
  isUnformatted: function isUnformatted(value) {
    return /\d\d\d\d-\d\d-\d\d/g.test(value);
  },
  format: function format(value, fieldFormatJson) {
    if (fieldFormatJson && fieldFormatJson.isRaw) {
      return value;
    }

    if (value) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(value).format(fieldFormatJson && fieldFormatJson.dateFormat || this.defaultFormat());
    }

    return '';
  },
  normalize: function normalize(value) {
    var normalizeFormat = 'YYYY-MM-DD';
    var momentValue = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(value);
    return momentValue.format(normalizeFormat);
  },
  getFormat: function getFormat(fieldFormatJson) {
    return fieldFormatJson.dateFormat || this.defaultFormat();
  }
};
/* harmony default export */ __webpack_exports__["a"] = (DateFormatter);

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18n_i18n__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isnumber__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isnumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isnumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);



var TimeFormatter = {
  rawFormat: 'HH:mm:ss',
  defaultFormat: function defaultFormat() {
    return __WEBPACK_IMPORTED_MODULE_0_i18n_i18n__["a" /* default */].t('metrics.formatting.time.default');
  },
  format: function format(value, fieldFormatJson) {
    var momentTime;

    if (fieldFormatJson && fieldFormatJson.isRaw) {
      return value;
    }

    if (value) {
      momentTime = this.extractMoment(value);

      if (momentTime.isValid()) {
        return momentTime.format(this.defaultFormat());
      }

      return __WEBPACK_IMPORTED_MODULE_0_i18n_i18n__["a" /* default */].t('metrics.formatting.time.error');
    }

    return '';
  },
  normalize: function normalize(value) {
    var normalizeFormat = 'HH:mm:ss';
    var momentValue = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(value);
    return momentValue.format(normalizeFormat);
  },
  isValid: function isValid(value) {
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value, this.rawFormat).isValid();
  },
  extractMoment: function extractMoment(value) {
    var timeParseFormats = ['HH:mm:ss', 'HH:mm'];
    var parseStrictly = true;
    var momentTime;
    var matches;

    if (__WEBPACK_IMPORTED_MODULE_1_lodash_isnumber___default()(value) && value > 0) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(value);
    }

    momentTime = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(value, timeParseFormats, parseStrictly);

    if (momentTime.isValid()) {
      return momentTime;
    }

    matches = /(\d\d:\d\d:\d\d).*/.exec(value);

    if (matches && matches.length > 1) {
      momentTime = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(matches[1], timeParseFormats, parseStrictly);
    } else {
      matches = /(\d\d:\d\d).*/.exec(value);

      if (matches && matches.length > 1) {
        momentTime = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(matches[1], timeParseFormats, parseStrictly);
      }
    }

    return momentTime;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (TimeFormatter);

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logger_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EventEmitter_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ResourceStore_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Translator_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__LanguageUtils_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PluralResolver_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Interpolator_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BackendConnector_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__defaults_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__postProcessor_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_js__ = __webpack_require__(45);




















function noop() {}

var I18n =
/*#__PURE__*/
function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, I18n);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(I18n).call(this));
    __WEBPACK_IMPORTED_MODULE_9__EventEmitter_js__["a" /* default */].call(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this))); // <=IE10 fix (unable to call parent constructor)

    _this.options = Object(__WEBPACK_IMPORTED_MODULE_16__defaults_js__["b" /* transformOptions */])(options);
    _this.services = {};
    _this.logger = __WEBPACK_IMPORTED_MODULE_8__logger_js__["a" /* default */];
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(_this, __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      this.options = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, Object(__WEBPACK_IMPORTED_MODULE_16__defaults_js__["a" /* get */])(), this.options, Object(__WEBPACK_IMPORTED_MODULE_16__defaults_js__["b" /* transformOptions */])(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      } // init services


      if (!this.options.isClone) {
        if (this.modules.logger) {
          __WEBPACK_IMPORTED_MODULE_8__logger_js__["a" /* default */].init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          __WEBPACK_IMPORTED_MODULE_8__logger_js__["a" /* default */].init(null, this.options);
        }

        var lu = new __WEBPACK_IMPORTED_MODULE_12__LanguageUtils_js__["a" /* default */](this.options);
        this.store = new __WEBPACK_IMPORTED_MODULE_10__ResourceStore_js__["a" /* default */](this.options.resources, this.options);
        var s = this.services;
        s.logger = __WEBPACK_IMPORTED_MODULE_8__logger_js__["a" /* default */];
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new __WEBPACK_IMPORTED_MODULE_13__PluralResolver_js__["a" /* default */](lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new __WEBPACK_IMPORTED_MODULE_14__Interpolator_js__["a" /* default */](this.options);
        s.backendConnector = new __WEBPACK_IMPORTED_MODULE_15__BackendConnector_js__["a" /* default */](createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options); // pipe events from backendConnector

        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new __WEBPACK_IMPORTED_MODULE_11__Translator_js__["a" /* default */](this.services, this.options); // pipe events from translator

        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      } // append api


      var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var deferred = Object(__WEBPACK_IMPORTED_MODULE_18__utils_js__["c" /* defer */])();

      var load = function load() {
        _this2.changeLanguage(_this2.options.lng, function (err, t) {
          _this2.isInitialized = true;

          _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t); // not rejecting on err (as err is only a loading translation failed warning)

          callback(err, t);
        });
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
    /* eslint consistent-return: 0 */

  }, {
    key: "loadResources",
    value: function loadResources() {
      var _this3 = this;

      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!this.language) {
          // at least load fallbacks in this case
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(this.language);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, callback);
      } else {
        callback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = Object(__WEBPACK_IMPORTED_MODULE_18__utils_js__["c" /* defer */])();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve(); // not rejecting on err (as err is only a loading translation failed warning)

        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        __WEBPACK_IMPORTED_MODULE_17__postProcessor_js__["a" /* default */].addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      var deferred = Object(__WEBPACK_IMPORTED_MODULE_18__utils_js__["c" /* defer */])();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        _this4.translator.changeLanguage(l);

        if (l) {
          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, opts);

        if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this6 = this;

      var deferred = Object(__WEBPACK_IMPORTED_MODULE_18__utils_js__["c" /* defer */])();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = Object(__WEBPACK_IMPORTED_MODULE_18__utils_js__["c" /* defer */])();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      }); // Exit early if all given languages are already preloaded

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
    /* eslint class-methods-use-this: 0 */

  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this7 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this7[m];
      });
      clone.translator = new __WEBPACK_IMPORTED_MODULE_11__Translator_js__["a" /* default */](clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options; // sync options

      return clone;
    }
  }]);

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_9__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new I18n());

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventEmitter_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(45);










var ResourceStore =
/*#__PURE__*/
function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ResourceStore);

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ResourceStore).call(this));
    __WEBPACK_IMPORTED_MODULE_7__EventEmitter_js__["a" /* default */].call(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this))); // <=IE10 fix (unable to call parent constructor)

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      return __WEBPACK_IMPORTED_MODULE_8__utils_js__["e" /* getPath */](this.data, path);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      __WEBPACK_IMPORTED_MODULE_8__utils_js__["i" /* setPath */](this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      /* eslint no-restricted-syntax: 0 */
      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = __WEBPACK_IMPORTED_MODULE_8__utils_js__["e" /* getPath */](this.data, path) || {};

      if (deep) {
        __WEBPACK_IMPORTED_MODULE_8__utils_js__["b" /* deepExtend */](pack, resources, overwrite);
      } else {
        pack = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, pack, resources);
      }

      __WEBPACK_IMPORTED_MODULE_8__utils_js__["i" /* setPath */](this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS; // COMPATIBILITY: remove extend in v2.1.0

      if (this.options.compatibilityAPI === 'v1') return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(__WEBPACK_IMPORTED_MODULE_7__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ResourceStore);

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logger_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EventEmitter_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__postProcessor_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_js__ = __webpack_require__(45);













var Translator =
/*#__PURE__*/
function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Translator);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Translator).call(this));
    __WEBPACK_IMPORTED_MODULE_9__EventEmitter_js__["a" /* default */].call(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this))); // <=IE10 fix (unable to call parent constructor)

    __WEBPACK_IMPORTED_MODULE_11__utils_js__["a" /* copy */](['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat'], services, __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = __WEBPACK_IMPORTED_MODULE_8__logger_js__["a" /* default */].create('translator');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator || this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options) {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        /* eslint prefer-rest-params: 0 */
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {}; // non valid keys handling

      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)]; // separators

      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator; // get namespace(s)

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1]; // return key on CIMode

      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      } // resolve from store


      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays; // object

      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        } // if we got a separator we loop over children - else we just return object as is
        // as having it set to false means no hierarchy so no lookup for nested values


        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {}; // apply child translation on a copy

          /* eslint no-restricted-syntax: 0 */

          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m]; // if nothing found use orginal value as fallback
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        // array special treatment
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options);
      } else {
        // string, empty or null
        var usedDefault = false;
        var usedKey = false; // fallback value

        if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
          usedDefault = true;

          if (options.count !== undefined) {
            var suffix = this.pluralResolver.getSuffix(lng, options.count);
            res = options["defaultValue".concat(suffix)];
          }

          if (!res) res = options.defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        } // save missing


        var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (l) {
                var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

                plurals.forEach(function (p) {
                  return send([l], p);
                });
              });
            } else {
              send(lngs, key);
            }
          }
        } // extend


        res = this.extendTranslation(res, keys, options, resolved); // append namespace if still key

        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key); // parseMissingKeyHandler

        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      } // return


      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        // i18next.parsing
        if (options.interpolation) this.interpolator.init(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, options, {
          interpolation: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, this.options.interpolation, options.interpolation)
        })); // interpolate

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options); // nesting

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          return _this3.translate.apply(_this3, arguments);
        }, options);
        if (options.interpolation) this.interpolator.reset();
      } // post process


      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = __WEBPACK_IMPORTED_MODULE_10__postProcessor_js__["a" /* default */].handle(postProcessorNames, res, key, options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey; // plain key

      var exactUsedKey; // key with context / plural

      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys]; // forEach possible key

      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;
          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count); // fallback for plural if context not found

              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix); // get key for context if needed

              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context)); // get key for plural if needed

              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            } // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only


            var possibleKey;
            /* eslint no-cond-assign: 0 */

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }]);

  return Translator;
}(__WEBPACK_IMPORTED_MODULE_9__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Translator);

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger_js__ = __webpack_require__(40);




function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil =
/*#__PURE__*/
function () {
  function LanguageUtil(options) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.whitelist || false;
    this.logger = __WEBPACK_IMPORTED_MODULE_2__logger_js__["a" /* default */].create('languageUtils');
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      // http://www.iana.org/assignments/language-tags/language-tags.xhtml
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase(); // if lenght 2 guess it's a country

          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks.default || []; // asume we have an object defining fallbacks

      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks.default;
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this.isWhitelisted(c)) {
          codes.push(c);
        } else {
          _this.logger.warn("rejecting non-whitelisted language code: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (LanguageUtil);

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger_js__ = __webpack_require__(40);


 // definition http://translate.sourceforge.net/wiki/l10n/pluralforms

/* eslint-disable */

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n === 1 ? 0 : n === 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver =
/*#__PURE__*/
function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = __WEBPACK_IMPORTED_MODULE_2__logger_js__["a" /* default */].create('pluralResolver');
    this.rules = createRules();
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var _this = this;

      var ret = [];
      var rule = this.getRule(code);
      if (!rule) return ret;
      rule.numbers.forEach(function (n) {
        var suffix = _this.getSuffix(code, n);

        ret.push("".concat(key).concat(suffix));
      });
      return ret;
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        // if (rule.numbers.length === 1) return ''; // only singular
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx]; // special treatment for lngs only having singular and plural

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        }; // COMPATIBILITY JSON
        // v1


        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (
        /* v2 */
        this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (
        /* v3 - gettext index */
        this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

/* harmony default export */ __webpack_exports__["a"] = (PluralResolver);

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logger_js__ = __webpack_require__(40);






var Interpolator =
/*#__PURE__*/
function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Interpolator);

    this.logger = __WEBPACK_IMPORTED_MODULE_4__logger_js__["a" /* default */].create('interpolator');
    this.init(options, true);
  }
  /* eslint no-param-reassign: 0 */


  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var reset = arguments.length > 1 ? arguments[1] : undefined;

      if (reset) {
        this.options = options;

        this.format = options.interpolation && options.interpolation.format || function (value) {
          return value;
        };
      }

      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : __WEBPACK_IMPORTED_MODULE_3__utils_js__["d" /* escape */];
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? __WEBPACK_IMPORTED_MODULE_3__utils_js__["h" /* regexEscape */](iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? __WEBPACK_IMPORTED_MODULE_3__utils_js__["h" /* regexEscape */](iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? __WEBPACK_IMPORTED_MODULE_3__utils_js__["h" /* regexEscape */](iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || __WEBPACK_IMPORTED_MODULE_3__utils_js__["h" /* regexEscape */]('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? __WEBPACK_IMPORTED_MODULE_3__utils_js__["h" /* regexEscape */](iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || __WEBPACK_IMPORTED_MODULE_3__utils_js__["h" /* regexEscape */](')');
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000; // the regexp

      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      // the regexp
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) return __WEBPACK_IMPORTED_MODULE_3__utils_js__["e" /* getPath */](data, key);
        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(__WEBPACK_IMPORTED_MODULE_3__utils_js__["e" /* getPath */](data, k), f, lng);
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      replaces = 0; // unescape if has unescapePrefix/Suffix

      /* eslint no-cond-assign: 0 */

      while (match = this.regexpUnescape.exec(str)) {
        value = handleFormat(match[1].trim());
        str = str.replace(match[0], value);
        this.regexpUnescape.lastIndex = 0;
        replaces++;

        if (replaces >= this.maxReplaces) {
          break;
        }
      }

      replaces = 0; // regular escape on demand

      while (match = this.regexp.exec(str)) {
        value = handleFormat(match[1].trim());

        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            var temp = missingInterpolationHandler(str, match, options);
            value = typeof temp === 'string' ? temp : '';
          } else {
            this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
            value = '';
          }
        } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
          value = __WEBPACK_IMPORTED_MODULE_3__utils_js__["f" /* makeString */](value);
        }

        value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
        replaces++;

        if (replaces >= this.maxReplaces) {
          break;
        }
      }

      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, options);

      clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup
      // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"

      function handleHasOptions(key, inheritedOptions) {
        if (key.indexOf(',') < 0) return key;
        var p = key.split(',');
        key = p.shift();
        var optionsString = p.join(',');
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.error("failed parsing options string in nesting for key ".concat(key), e);
        }

        return key;
      } // regular escape on demand


      while (match = this.nestingRegexp.exec(str)) {
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions); // is only the nesting key (key1 = '$(key2)') return the value without stringify

        if (value && match[0] === str && typeof value !== 'string') return value; // no string to include or empty

        if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_3__utils_js__["f" /* makeString */](value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        } // Nested keys should not be escaped by default #854
        // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);


        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

/* harmony default export */ __webpack_exports__["a"] = (Interpolator);

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logger_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EventEmitter_js__ = __webpack_require__(50);












function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector =
/*#__PURE__*/
function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Connector);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Connector).call(this));
    __WEBPACK_IMPORTED_MODULE_10__EventEmitter_js__["a" /* default */].call(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this))); // <=IE10 fix (unable to call parent constructor)

    _this.backend = backend;
    _this.store = store;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_9__logger_js__["a" /* default */].create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      // find what needs to be loaded
      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2; // loaded
          } else if (_this2.state[name] < 0) {// nothing to do for err
          } else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1; // pending

            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var _name$split = name.split('|'),
          _name$split2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_name$split, 2),
          lng = _name$split2[0],
          ns = _name$split2[1];

      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      } // set loaded


      this.state[name] = err ? -1 : 2; // consolidated loading done in this run - only emit once for a loaded namespace

      var loaded = {}; // callback if ready

      this.queue.forEach(function (q) {
        __WEBPACK_IMPORTED_MODULE_8__utils_js__["g" /* pushPath */](q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          // only do once per loaded -> this.emit('loaded', q.loaded);
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          /* eslint no-param-reassign: 0 */

          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      }); // emit consolidated loaded event

      this.emit('loaded', loaded); // remove done load requests

      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {}); // noting to load

      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data
        /* = retryFlag */
        && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
    /* eslint consistent-return: 0 */

  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now

        return null; // pendings will trigger callback
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var _name$split3 = name.split('|'),
          _name$split4 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_name$split3, 2),
          lng = _name$split4[0],
          ns = _name$split4[1];

      this.read(lng, ns, 'read', null, null, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null
        /* unused callback */
        , __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, options, {
          isUpdate: isUpdate
        }));
      } // write to store to avoid resending


      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_10__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),

/***/ 149:
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = transformOptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    // string or array of namespaces
    whitelist: false,
    // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all',
    // | currentOnly | languageOnly
    preload: false,
    // array with preload languages
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    // allow bundling certain languages that are not remotely fetched
    saveMissing: false,
    // enable to send missing values
    updateMissing: false,
    // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback',
    // 'current' || 'all'
    saveMissingPlurals: true,
    // will save all forms not only singular key
    missingKeyHandler: false,
    // function(lng, ns, key, fallbackValue) -> override if prefer on handling
    missingInterpolationHandler: false,
    // function(str, match)
    postProcess: false,
    // string or array of postProcessor names
    returnNull: true,
    // allows null value as valid translation
    returnEmptyString: true,
    // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false,
    // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {},
    // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false,
    // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(args[2]) === 'object' || __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop

    }
  };
}
/* eslint no-param-reassign: 0 */

function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS]; // extend whitelist with cimode

  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
    options.whitelist = options.whitelist.concat(['cimode']);
  }

  return options;
}

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : Bulgarian
// author : Don Vince : https://github.com/donvince/

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'bg', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: { // I found these here http://www.unicode.org/cldr/charts/28/verify/numbers/bg.html
            thousand: 'хил',
            million: 'млн',
            billion: 'млрд',
            trillion: 'трлн'
        },
        ordinal: function (number) {
            // google translate suggests:
            // 1st=1-ви; 2nd=2-ри; 7th=7-ми;
            // 8th=8-ми and many others end with -ти
            // for example 3rd=3-ти
            // However since I've seen suggestions that in
            // Bulgarian the ordinal can be taken in
            // different forms (masculine, feminine, neuter)
            // I've opted to wimp out on commiting that to code
            return '';
        },
        currency: {
            symbol: 'лв'
        }
    });
}));


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : simplified chinese (chs)
// author : badplum : https://github.com/badplum

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'chs', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: '千',
            million: '百万',
            billion: '十亿',
            trillion: '兆'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '¥'
        }
    });
}));


/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : czech (cs)
// author : Anatoli Papirovski : https://github.com/apapirovski

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'cs', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tis.',
            million: 'mil.',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'Kč'
        }
    });
}));


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : danish denmark (dk)
// author : Michael Storgaard : https://github.com/mstorgaard

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'da-dk', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mio',
            billion: 'mia',
            trillion: 'b'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'DKK'
        }
    });
}));


/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : German (de) – generally useful in Germany, Austria, Luxembourg, Belgium
// author : Marco Krage : https://github.com/sinky

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'de', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
}));


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : German in Switzerland (de-ch)
// author : Michael Piefel : https://github.com/piefel (based on work from Marco Krage : https://github.com/sinky)

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'de-ch', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'CHF'
        }
    });
}));


/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : English Australia
// author : Don Vince : https://github.com/donvince/

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'en-au', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });
}));


/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : english united kingdom (uk)
// author : Dan Ristic : https://github.com/dristic

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'en-gb', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '£'
        }
    });
}));


/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : english south africa (uk)
// author : Etienne Boshoff : etienne@zailab.com

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'en-za', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                    (b === 2) ? 'nd' :
                        (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: 'R'
        }
    });
}));


/***/ }),

/***/ 16:
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : spanish
// author : Hernan Garcia : https://github.com/hgarcia

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'es', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                (b === 7 || b === 0) ? 'mo' :
		(b === 8) ? 'vo' :
		(b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '$'
        }
    });
}));


/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : spanish Spain
// author : Hernan Garcia : https://github.com/hgarcia

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'es-es', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                    (b === 7 || b === 0) ? 'mo' :
                        (b === 8) ? 'vo' :
                            (b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '€'
        }
    });
}));


/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : Estonian
// author : Illimar Tambek : https://github.com/ragulka
// Note: in Estonian, abbreviations are always separated from numbers with a space

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'et', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: ' tuh',
            million: ' mln',
            billion: ' mld',
            trillion: ' trl'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
}));


/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : Finnish
// author : Sami Saada : https://github.com/samitheberber

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'fi', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'M',
            billion: 'G',
            trillion: 'T'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
}));


/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : french (fr)
// author : Adam Draper : https://github.com/adamwdraper

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'fr', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'e';
        },
        currency: {
            symbol: '€'
        }
    });
}));


/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : french (Canada) (fr-ca)
// author : Léo Renaud-Allaire : https://github.com/renaudleo

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'fr-ca', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'M',
            billion: 'G',
            trillion: 'T'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'e';
        },
        currency: {
            symbol: '$'
        }
    });
}));


/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : french (fr-ch)
// author : Adam Draper : https://github.com/adamwdraper

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'fr-ch', {
        delimiters: {
            thousands: '\'',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'e';
        },
        currency: {
            symbol: 'CHF'
        }
    });
}));


/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : Hungarian (hu)
// author : Peter Bakondy : https://github.com/pbakondy

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'hu', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'E',  // ezer
            million: 'M',   // millió
            billion: 'Mrd', // milliárd
            trillion: 'T'   // trillió
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: ' Ft'
        }
    });
}));


/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : italian Italy (it)
// author : Giacomo Trombi : http://cinquepunti.it

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'it', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'mila',
            million: 'mil',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return 'º';
        },
        currency: {
            symbol: '€'
        }
    });
}));


/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : japanese
// author : teppeis : https://github.com/teppeis

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'ja', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: '千',
            million: '百万',
            billion: '十億',
            trillion: '兆'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '¥'
        }
    });
}));


/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : Latvian (lv)
// author : Lauris Bukšis-Haberkorns : https://github.com/Lafriks

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'lv', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: ' tūkst.',
            million: ' milj.',
            billion: ' mljrd.',
            trillion: ' trilj.'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
}));


/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : dutch-belgium (nl-be)
// author : Dieter Luypaert : https://github.com/moeriki
// corrected : Olivier Godefroy : https://github.com/godefroyo

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'nl-be', {
        delimiters: {
            thousands: ' ',
            decimal  : ','
        },
        abbreviations: {
            thousand : 'k',
            million  : ' mln',
            billion  : ' mld',
            trillion : ' bln'
        },
        ordinal : function (number) {
            var remainder = number % 100;

            return (number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20) ? 'ste' : 'de';
        },
        currency: {
            symbol: '€ '
        }
    });
}));


/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : netherlands-dutch (nl-nl)
// author : Dave Clayton : https://github.com/davedx

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'nl-nl', {
        delimiters: {
            thousands: '.',
            decimal  : ','
        },
        abbreviations: {
            thousand : 'k',
            million  : 'mln',
            billion  : 'mrd',
            trillion : 'bln'
        },
        ordinal : function (number) {
            var remainder = number % 100;
            return (number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20) ? 'ste' : 'de';
        },
        currency: {
            symbol: '€ '
        }
    });
}));


/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : norwegian (bokmål)
// author : Ove Andersen : https://github.com/azzlack

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'no', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'kr'
        }
    });
}));


/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : polish (pl)
// author : Dominik Bulaj : https://github.com/dominikbulaj

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'pl', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tys.',
            million: 'mln',
            billion: 'mld',
            trillion: 'bln'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'PLN'
        }
    });
}));


/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : portuguese brazil (pt-br)
// author : Ramiro Varandas Jr : https://github.com/ramirovjr

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'pt-br', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'mil',
            million: 'milhões',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return 'º';
        },
        currency: {
            symbol: 'R$'
        }
    });
}));


/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : portuguese (pt-pt)
// author : Diogo Resende : https://github.com/dresende

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'pt-pt', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function (number) {
            return 'º';
        },
        currency: {
            symbol: '€'
        }
    });
}));


/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : russian (ru)
// author : Anatoli Papirovski : https://github.com/apapirovski

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'ru', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тыс.',
            million: 'млн.',
            billion: 'млрд.',
            trillion: 'трлн.'
        },
        ordinal: function () {
            // not ideal, but since in Russian it can taken on
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return '.';
        },
        currency: {
            symbol: 'руб.'
        }
    });
}));


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : Russian for the Ukraine (ru-ua)
// author : Anatoli Papirovski : https://github.com/apapirovski

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'ru-ua', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тыс.',
            million: 'млн',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            // not ideal, but since in Russian it can taken on
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return '.';
        },
        currency: {
            symbol: '\u20B4'
        }
    });
}));


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : slovak (sk)
// author : Ahmed Al Hafoudh : http://www.freevision.sk

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'sk', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tis.',
            million: 'mil.',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
}));


/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : slovenian (sl)
// author : Boštjan Pišler : https://github.com/BostjanPisler

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'sl', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mio',
            billion: 'mrd',
            trillion: 'trilijon'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
}));


/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : thai (th)
// author : Sathit Jittanupat : https://github.com/jojosati

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {


    numeral.register('locale', 'th', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'พัน',
            million: 'ล้าน',
            billion: 'พันล้าน',
            trillion: 'ล้านล้าน'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '฿'
        }
    });
}));


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : turkish (tr)
// author : Ecmel Ercan : https://github.com/ecmel, Erhan Gundogan : https://github.com/erhangundogan, Burak Yiğit Kaya: https://github.com/BYK

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    var suffixes = {
            1: '\'inci',
            5: '\'inci',
            8: '\'inci',
            70: '\'inci',
            80: '\'inci',

            2: '\'nci',
            7: '\'nci',
            20: '\'nci',
            50: '\'nci',

            3: '\'üncü',
            4: '\'üncü',
            100: '\'üncü',

            6: '\'ncı',

            9: '\'uncu',
            10: '\'uncu',
            30: '\'uncu',

            60: '\'ıncı',
            90: '\'ıncı'
        };

    numeral.register('locale', 'tr', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'bin',
            million: 'milyon',
            billion: 'milyar',
            trillion: 'trilyon'
        },
        ordinal: function (number) {
            if (number === 0) {  // special case for zero
                return '\'ıncı';
            }

            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;

          return suffixes[a] || suffixes[b] || suffixes[c];
        },
        currency: {
            symbol: '\u20BA'
        }
    });
}));


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : Ukrainian for the Ukraine (uk-ua)
// author : Michael Piefel : https://github.com/piefel (with help from Tetyana Kuzmenko)

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    numeral.register('locale', 'uk-ua', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тис.',
            million: 'млн',
            billion: 'млрд',
            trillion: 'блн'
        },
        ordinal: function () {
            // not ideal, but since in Ukrainian it can taken on
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return '';
        },
        currency: {
            symbol: '\u20B4'
        }
    });
}));


/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// numeral.js locale configuration
// locale : vietnam (vi)
// author : Harry Nguyen : https://github.com/thaihoa311

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        factory(require('../numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {

    numeral.register('locale', 'vi', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: ' nghìn',
            million: ' triệu',
            billion: ' tỷ',
            trillion: ' nghìn tỷ'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '₫'
        }
    });
}));


/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./bg": 151,
	"./bg.js": 151,
	"./chs": 152,
	"./chs.js": 152,
	"./cs": 153,
	"./cs.js": 153,
	"./da-dk": 154,
	"./da-dk.js": 154,
	"./de": 155,
	"./de-ch": 156,
	"./de-ch.js": 156,
	"./de.js": 155,
	"./en-au": 157,
	"./en-au.js": 157,
	"./en-gb": 158,
	"./en-gb.js": 158,
	"./en-za": 159,
	"./en-za.js": 159,
	"./es": 160,
	"./es-es": 161,
	"./es-es.js": 161,
	"./es.js": 160,
	"./et": 162,
	"./et.js": 162,
	"./fi": 163,
	"./fi.js": 163,
	"./fr": 164,
	"./fr-ca": 165,
	"./fr-ca.js": 165,
	"./fr-ch": 166,
	"./fr-ch.js": 166,
	"./fr.js": 164,
	"./hu": 167,
	"./hu.js": 167,
	"./it": 168,
	"./it.js": 168,
	"./ja": 169,
	"./ja.js": 169,
	"./lv": 170,
	"./lv.js": 170,
	"./nl-be": 171,
	"./nl-be.js": 171,
	"./nl-nl": 172,
	"./nl-nl.js": 172,
	"./no": 173,
	"./no.js": 173,
	"./pl": 174,
	"./pl.js": 174,
	"./pt-br": 175,
	"./pt-br.js": 175,
	"./pt-pt": 176,
	"./pt-pt.js": 176,
	"./ru": 177,
	"./ru-ua": 178,
	"./ru-ua.js": 178,
	"./ru.js": 177,
	"./sk": 179,
	"./sk.js": 179,
	"./sl": 180,
	"./sl.js": 180,
	"./th": 181,
	"./th.js": 181,
	"./tr": 182,
	"./tr.js": 182,
	"./uk-ua": 183,
	"./uk-ua.js": 183,
	"./vi": 184,
	"./vi.js": 184
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 224;

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18n_i18n__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dateFormatter__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timeFormatter__ = __webpack_require__(137);




var DatetimeFormatter = {
  rawFormat: "".concat(__WEBPACK_IMPORTED_MODULE_2__dateFormatter__["a" /* default */].rawFormat, " ").concat(__WEBPACK_IMPORTED_MODULE_3__timeFormatter__["a" /* default */].rawFormat),
  defaultFormat: function defaultFormat() {
    return __WEBPACK_IMPORTED_MODULE_0_i18n_i18n__["a" /* default */].t('metrics.formatting.datetime.default');
  },
  isUnformatted: function isUnformatted(value) {
    return /\d\d\d\d-\d\d-\d\d \d\d:\d\d(:\d\d)?/g.test(value);
  },
  format: function format(value, fieldFormatJson) {
    var utcOffsetMinutes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var datetimeFormat;
    var displayTime;
    var formatToUse;

    if (fieldFormatJson && fieldFormatJson.isRaw) {
      return value;
    }

    if (value) {
      datetimeFormat = fieldFormatJson && fieldFormatJson.datetimeFormat;
      displayTime = fieldFormatJson && typeof fieldFormatJson.displayTime !== 'undefined' ? fieldFormatJson.displayTime : true;

      if (displayTime) {
        if (datetimeFormat) {
          formatToUse = datetimeFormat;
        } else {
          formatToUse = this.defaultFormat();
        }
      } else {
        // eslint-disable-next-line
        if (fieldFormatJson && datetimeFormat) {
          formatToUse = this.removeTime(datetimeFormat);
        } else {
          formatToUse = __WEBPACK_IMPORTED_MODULE_2__dateFormatter__["a" /* default */].defaultFormat();
        }
      }

      var momentValue = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(value);
      momentValue = utcOffsetMinutes ? momentValue.utcOffset(utcOffsetMinutes) : momentValue;
      return momentValue.format(formatToUse);
    }

    return '';
  },
  normalize: function normalize(value) {
    var normalizeFormat = 'YYYY-MM-DD HH:mm:ss';
    var momentValue = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(value);
    return momentValue.format(normalizeFormat);
  },
  getFormat: function getFormat(fieldFormatJson) {
    return fieldFormatJson.displayTime !== false ? fieldFormatJson.datetimeFormat || this.defaultFormat() : this.removeTime(fieldFormatJson.datetimeFormat) || __WEBPACK_IMPORTED_MODULE_2__dateFormatter__["a" /* default */].defaultFormat();
  },
  removeTime: function removeTime(temporalFormat) {
    return temporalFormat ? temporalFormat.replace(' h:mm:ss A', '') : '';
  }
};
/* harmony default export */ __webpack_exports__["a"] = (DatetimeFormatter);

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18n_i18n__ = __webpack_require__(31);

var TRUTHFUL_VALUES = ['t', 'true', '1', 'yes'];
var LogicalFormatter = {
  format: function format(value, fieldFormatJson) {
    if (fieldFormatJson && fieldFormatJson.isRaw) {
      return value;
    }

    var isTruthfulValue = TRUTHFUL_VALUES.indexOf(String(value).toLowerCase()) !== -1;
    var stringBool = isTruthfulValue ? 'true' : 'false';
    return __WEBPACK_IMPORTED_MODULE_0_i18n_i18n__["a" /* default */].t("metrics.formatting.logical.".concat(stringBool));
  }
};
/* harmony default export */ __webpack_exports__["a"] = (LogicalFormatter);

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);


var NumberFormatter = {
  format: function format(n, fieldFormatJson) {
    var s;
    var parts;
    var exponent;

    if (fieldFormatJson && (fieldFormatJson.isRaw || fieldFormatJson.hasOnlyRadixSeparator && typeof fieldFormatJson.precision === 'undefined')) {
      return n;
    }

    if (n === undefined || n === null || n === '') {
      return '';
    }

    var postfix = fieldFormatJson && typeof fieldFormatJson.postfix !== 'undefined' ? fieldFormatJson.postfix : '';
    s = Number(n).toString();

    if (s.indexOf('e') >= 0) {
      if (postfix === '%') {
        parts = s.split('e');
        exponent = Number(parts[1]);

        if (exponent === 0) {
          var _parts = parts;

          var _parts2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_parts, 1);

          s = _parts2[0];
          return getPrecisionNumberString(Number(s), s, fieldFormatJson);
        }

        s = "".concat(parts[0], "e").concat(exponent < 0 ? '-' : '+').concat(Math.abs(exponent + 2));
      }

      return getSignedNumberString(n, s.slice(n < 0 ? 1 : 0), fieldFormatJson);
    }

    if (postfix === '%') {
      s = n.toString();
      s += 'e+2';
      s = Number(s).toString();
    }

    return getPrecisionNumberString(Number(s), s, fieldFormatJson);
  },
  isFormattedNumber: function isFormattedNumber(str, fieldFormatJson) {
    var prefix = fieldFormatJson && fieldFormatJson.prefix ? "(".concat(escapeRegexComponent(fieldFormatJson.prefix), ")?") : '';
    var thousandsDelimiter = escapeRegexComponent(__WEBPACK_IMPORTED_MODULE_1_numeral___default.a.localeData().delimiters.thousands);
    var decimalDelimiter = escapeRegexComponent(__WEBPACK_IMPORTED_MODULE_1_numeral___default.a.localeData().delimiters.decimal);
    var abbreviation = getAbbreviationPattern();
    var postfix = fieldFormatJson && fieldFormatJson.postfix ? "(".concat(escapeRegexComponent(fieldFormatJson.postfix), ")?") : '';
    var innerExpression = "(".concat(prefix, "((\\d{1,3}(").concat(thousandsDelimiter, "\\d{3})*|\\d+)(").concat(decimalDelimiter, "\\d+)?|").concat(decimalDelimiter, "\\d+)(").concat(abbreviation, ")?").concat(postfix, ")");
    var expression = "^(".concat(innerExpression, "|-").concat(innerExpression, "|\\(").concat(innerExpression, "\\))$");
    return new RegExp(expression).test(str);
  }
};

function getPrecisionNumberString(number, numberString, fieldFormatJson) {
  var precision = fieldFormatJson && typeof fieldFormatJson.precision !== 'undefined' ? fieldFormatJson.precision : null;
  var shouldAbbreviate = fieldFormatJson && typeof fieldFormatJson.abbreviate !== 'undefined' ? fieldFormatJson.abbreviate : false;
  var keepTrailingZeros = fieldFormatJson && typeof fieldFormatJson.keepTrailingZeros !== 'undefined' ? fieldFormatJson.keepTrailingZeros : false;
  var decimalDelimiter = __WEBPACK_IMPORTED_MODULE_1_numeral___default.a && __WEBPACK_IMPORTED_MODULE_1_numeral___default.a.localeData() ? __WEBPACK_IMPORTED_MODULE_1_numeral___default.a.localeData().delimiters.decimal : '.';
  var thousandsDelimiter;

  if (fieldFormatJson && fieldFormatJson.hasOnlyRadixSeparator) {
    thousandsDelimiter = false;
  } else {
    thousandsDelimiter = fieldFormatJson && typeof fieldFormatJson.thousandsDelimiter !== 'undefined' ? fieldFormatJson.thousandsDelimiter : true;
  }

  if (precision === null) {
    precision = getExistingPrecision(numberString);
  }

  var format = getNumeralFormatString(shouldAbbreviate, thousandsDelimiter, precision, number);
  var result = __WEBPACK_IMPORTED_MODULE_1_numeral___default()(number).format(format).replace('-', '');

  if (!keepTrailingZeros && result.indexOf(decimalDelimiter) > -1) {
    result = removeTrailingZeros(shouldAbbreviate, result);
  }

  return getSignedNumberString(number, result, fieldFormatJson);
}

function getSignedNumberString(number, numberString, fieldFormatJson) {
  var prefix = fieldFormatJson && typeof fieldFormatJson.prefix !== 'undefined' ? fieldFormatJson.prefix : '';
  var postfix = fieldFormatJson && typeof fieldFormatJson.postfix !== 'undefined' ? fieldFormatJson.postfix : '';
  var sign = fieldFormatJson && typeof fieldFormatJson.sign !== 'undefined' ? fieldFormatJson.sign : '';

  if (number < 0) {
    if (sign === '(') {
      return "(".concat(prefix).concat(numberString).concat(postfix, ")");
    }

    return "-".concat(prefix).concat(numberString).concat(postfix);
  }

  return prefix + numberString + postfix;
}

function getExistingPrecision(numberString) {
  var decimalIndex = numberString.indexOf('.');
  var decimalValue = decimalIndex >= 0 ? numberString.slice(decimalIndex + 1) : '';
  return decimalValue.length;
}

function getNumeralFormatString(shouldAbbreviate, thousandsDelimiter, precision, number) {
  var format = shouldAbbreviate || !thousandsDelimiter ? '0' : '0,0';
  var j;

  if (precision > 0 && !Number.isNaN(number)) {
    format += '.';

    for (j = 0; j < precision; j++) {
      format += '0';
    }
  }

  if (shouldAbbreviate) {
    format += 'a';
  }

  return format;
}

function removeTrailingZeros(shouldAbbreviate, numberString) {
  var numberStringCopy;
  var numberCopy;

  if (shouldAbbreviate && /[a-zA-Z]/.test(numberString.charAt(numberString.length - 1))) {
    numberStringCopy = numberString.substr(0, numberString.length - 1);
    numberCopy = parseFloat(numberStringCopy); // this will remove trailing zeros

    return numberCopy + numberString.charAt(numberString.length - 1).toUpperCase();
  }

  return numberString.replace(/\.?0+$/, '');
}

function escapeRegexComponent(str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}

function getAbbreviationPattern() {
  var abbreviationsObj = __WEBPACK_IMPORTED_MODULE_1_numeral___default.a.localeData().abbreviations;
  return Object.keys(abbreviationsObj).reduce(function (accumulator, value) {
    accumulator.push(abbreviationsObj[value].toLowerCase());
    accumulator.push(abbreviationsObj[value].toUpperCase());
    return accumulator;
  }, []).join('|');
}

/* harmony default export */ __webpack_exports__["a"] = (NumberFormatter);

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PercentageFormatter = {
  format: function format(value, fieldFormatJson) {
    if (fieldFormatJson && fieldFormatJson.isRaw) {
      return value;
    }

    return "".concat(Math.round(value * 1000) / 10, "%");
  }
};
/* harmony default export */ __webpack_exports__["a"] = (PercentageFormatter);

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18n_i18n__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dateFormatter__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datetimeFormatter__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logicalFormatter__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__numberFormatter__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__percentageFormatter__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__timeFormatter__ = __webpack_require__(137);







var TableDataFormatter = {
  formatValue: function formatValue(value, type, fieldFormatJson) {
    var formatBlanks = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var utcOffsetMinutes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

    if ((typeof value === 'undefined' || value === null || value === '') && formatBlanks) {
      var blankString = __WEBPACK_IMPORTED_MODULE_0_i18n_i18n__["a" /* default */].t('metrics.formatting.blank');
      return blankString;
    } // FIXME: Can we remove all the extra cases? e.g., D, dateTime, DT, N


    switch (type) {
      case 'date':
      case 'D':
        return __WEBPACK_IMPORTED_MODULE_1__dateFormatter__["a" /* default */].format(value, fieldFormatJson);

      case 'dateTime':
      case 'datetime':
      case 'DT':
        return __WEBPACK_IMPORTED_MODULE_2__datetimeFormatter__["a" /* default */].format(value, fieldFormatJson, utcOffsetMinutes);

      case 'time':
        return __WEBPACK_IMPORTED_MODULE_6__timeFormatter__["a" /* default */].format(value, fieldFormatJson);

      case 'logical':
        return __WEBPACK_IMPORTED_MODULE_3__logicalFormatter__["a" /* default */].format(value, fieldFormatJson);

      case 'numeric':
      case 'number':
      case 'N':
        return __WEBPACK_IMPORTED_MODULE_4__numberFormatter__["a" /* default */].format(value, fieldFormatJson);

      case 'percentage':
      case 'percent':
        return __WEBPACK_IMPORTED_MODULE_5__percentageFormatter__["a" /* default */].format(value, fieldFormatJson);

      default:
        return value === null || value === undefined ? '' : value;
    }
  },
  normalizeValue: function normalizeValue(value, dataType) {
    switch (dataType) {
      case 'datetime':
        return __WEBPACK_IMPORTED_MODULE_2__datetimeFormatter__["a" /* default */].normalize(value);

      case 'date':
        return __WEBPACK_IMPORTED_MODULE_1__dateFormatter__["a" /* default */].normalize(value);

      case 'time':
        return __WEBPACK_IMPORTED_MODULE_6__timeFormatter__["a" /* default */].normalize(value);

      default:
        return value;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (TableDataFormatter);

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && objectToString.call(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18next__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locales__ = __webpack_require__(82);


var defaultLocale = 'en';

var i18n = function i18n(locale) {
  var resource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return new Promise(function (res, rej) {
    if (locale) {
      i18n.config.lng = locale;
    }

    if (resource) {
      i18n.config.resources = resource;
    }

    __WEBPACK_IMPORTED_MODULE_0_i18next__["default"].init(i18n.config, function (err, t) {
      if (err) {
        rej(err);
      } else {
        res(__WEBPACK_IMPORTED_MODULE_0_i18next__["default"], t);

        i18n.t = function () {
          return __WEBPACK_IMPORTED_MODULE_0_i18next__["default"].t.apply(__WEBPACK_IMPORTED_MODULE_0_i18next__["default"], arguments);
        };
      }
    });
  });
};

i18n.t = function () {};

i18n.config = {
  lng: defaultLocale,
  fallbackLng: defaultLocale,
  lowerCaseLng: true,
  resources: __WEBPACK_IMPORTED_MODULE_1__locales__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(15);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray__);




var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray___default()(args));
  }
};

var Logger =
/*#__PURE__*/
function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Logger);

    this.init(concreteLogger, options);
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Logger());

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = defer;
/* harmony export (immutable) */ __webpack_exports__["f"] = makeString;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["i"] = setPath;
/* harmony export (immutable) */ __webpack_exports__["g"] = pushPath;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = deepExtend;
/* harmony export (immutable) */ __webpack_exports__["h"] = regexEscape;
/* harmony export (immutable) */ __webpack_exports__["d"] = escape;
// http://lea.verou.me/2016/12/resolve-promises-externally-with-this-one-weird-trick/
function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */

  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }

  return target;
}
function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
/* eslint-disable */

var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);



var EventEmitter =
/*#__PURE__*/
function () {
  function EventEmitter() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, EventEmitter);

    this.observers = {};
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      var _this2 = this;

      if (!this.observers[event]) {
        return;
      }

      this.observers[event].forEach(function () {
        if (!listener) {
          delete _this2.observers[event];
        } else {
          var index = _this2.observers[event].indexOf(listener);

          if (index > -1) {
            _this2.observers[event].splice(index, 1);
          }
        }
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventEmitter);

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_53__;

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(147);

var iterableToArrayLimit = __webpack_require__(148);

var unsupportedIterableToArray = __webpack_require__(81);

var nonIterableRest = __webpack_require__(149);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(117);

var iterableToArray = __webpack_require__(118);

var unsupportedIterableToArray = __webpack_require__(81);

var nonIterableSpread = __webpack_require__(119);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(72);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var locales = {};
['en', 'de', 'fr', 'es', 'pt', 'ja', 'zh'].forEach(function (lng) {
  // eslint-disable-next-line
  Object.assign(locales, __webpack_require__(120)("./".concat(lng, ".yml")));
});
/* harmony default export */ __webpack_exports__["a"] = (locales);

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
});

/***/ })

/******/ });
});
//# sourceMappingURL=Formatters.js.map